require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboard/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('bestuurslid')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabestuurslid', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('bestuurslid')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabestuurslid', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/c534a8d5750e13aae825a92162bcb99a/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator')) {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn73mwn' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriopljm') {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/c5344aaa-a33b-47ca-935a-947a53073115/page/JwRwC';
    } else {
      URL2 = 'https://lookerstudio.google.com/embed/reporting/efc1f68a-e575-4d45-873c-f8cc200aee8e/page/JwRwC';
    }
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    URL2 = 'https://lookerstudio.google.com/embed/reporting/67c8cb4a-6ee9-4981-bd81-85d5a1349939/page/JwRwC';
  }

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('beheerder'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/cbe40e7fe223de879fdcc794e22ef1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cbe40e7fe223de879fdcc794e22ef1b2', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/5f4671d2f6343e8584e8771e9352d2b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('betalingsgegevens').save( ___arguments.context.getComponentDataStoreByUid('4bfb81ae6eba1e373cc65e6db10b6a5b') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/ac87c8fa16e485d293199495c6720a16/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('betalingsgegevens').save( ___arguments.context.getComponentDataStoreByUid('714a0c8633e1f918d035dd02501dd972') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/f7e9fdb494526a65029b5a5baa728dfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('betalingsgegevens').save( ___arguments.context.getComponentDataStoreByUid('41b9b708574edee12745be114f1ce87b') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/fb13e3e3e27b9c617ae879cd7fd824c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('betalingsgegevens').save( ___arguments.context.getComponentDataStoreByUid('7806a82e1e0b7219023eb695d3d6bffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/25c914c5171ae269b454e393f72304e6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('betalingsgegevens').save( ___arguments.context.getComponentDataStoreByUid('945b92fb547905ea356fb78653711ebf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/1d273ce6120df6f357413d362015c2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('betalingsgegevens').save( ___arguments.context.getComponentDataStoreByUid('0005620b263de57fecf864bd787d1c0c') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/7ed532a8f53286c87ccbc39c0bc1050c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('betalingsgegevens').save( ___arguments.context.getComponentDataStoreByUid('73d414b6875d33b853a27959c90e2bf9') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/155843c3ee75dc8565aa945e045590f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('betalingsgegevens').save( ___arguments.context.getComponentDataStoreByUid('59dc08dff734627166bbf4512ffdfbbe') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/d9fea68fd0af4ca6d4d599bd7d835f69/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnbetalingsgegevens/components/3b843605270d025bc784a5e860c4ca53/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/c61e972ea44d60bf24f273727da2add6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('soort').find(Backendless.DataQueryBuilder.create().setWhereClause((['actief = 1 ','AND rol LIKE\'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),'%\' AND subsidie LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'subsidie')),'%\''].join(''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'soort')),'label': (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var parameters;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['uren'] = null;
  ___arguments.context.pageData['kilometers'] = null;
  ___arguments.context.pageData['bedraginput'] = null;
  ___arguments.context.pageData['betreft'] = null;
  ___arguments.context.pageData['omschrijving'] = null;
  parameters = (await Promise.all((await Backendless.Data.of('soort').find(Backendless.DataQueryBuilder.create().setWhereClause((['soort=\'',(getObjectProperty(___arguments.context.pageData, 'soort')),'\' AND rol =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),'\' AND subsidie =\'',(getObjectProperty(___arguments.context.pageData, 'subsidie')),'\''].join(''))).setPageSize(100))).map(async parameters => {; return ({ [`uren`]: (getObjectProperty(parameters, 'auren')),[`kilometers`]: (getObjectProperty(parameters, 'akilometers')),[`bedrag`]: (getObjectProperty(parameters, 'abedrag')),[`betreft`]: (getObjectProperty(parameters, 'abetreft')),[`omschrijving`]: (getObjectProperty(parameters, 'aomschrijving')),[`bedragtitel`]: (getObjectProperty(parameters, 'bedragtitel')),[`bedragomschrijving`]: (getObjectProperty(parameters, 'bedragomschrijving')) });})))[0];
  ___arguments.context.pageData['paramuren'] = (getObjectProperty(parameters, 'uren'));
  ___arguments.context.pageData['paramkilometers'] = (getObjectProperty(parameters, 'kilometers'));
  ___arguments.context.pageData['parambedrag'] = (getObjectProperty(parameters, 'bedrag'));
  ___arguments.context.pageData['parambetreft'] = (getObjectProperty(parameters, 'betreft'));
  ___arguments.context.pageData['paramomschrijving'] = (getObjectProperty(parameters, 'omschrijving'));
  ___arguments.context.pageData['bedragtitel'] = (getObjectProperty(parameters, 'bedragtitel'));
  ___arguments.context.pageData['bedragomschrijving'] = (getObjectProperty(parameters, 'bedragomschrijving'));
  if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    ___arguments.context.pageData['bedraginput'] = 200;
  } else if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NCZSD') {
    ___arguments.context.pageData['bedraginput'] = 200;
  } else if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Coördinatorenoverleg' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    ___arguments.context.pageData['bedraginput'] = 200;
  } else {
    ___arguments.context.pageData['bedraginput'] = null;
    ___arguments.context.pageData['uren'] = null;
    ___arguments.context.pageData['kilometers'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var uurtarief, bedraginput, timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2c935f216085692a30788fa699be4e1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datum')) == null) {
    (function (message) { alert(message) })('Datum activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93bcca9d573c69a789f4e01a016dbf16')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'subsidie')) == null) {
    (function (message) { alert(message) })('Subsidie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c61e972ea44d60bf24f273727da2add6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'soort')) == null) {
    (function (message) { alert(message) })('Soort dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('646c72c5b7de6d7edd5b6d39fc94eb67')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'betreft')) == null) {
    (function (message) { alert(message) })('Betreft dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('52048d8528aa762cc2b47b9c6f557476')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'naambestuurslidprogrammamanager')) == null) {
    (function (message) { alert(message) })('Naam bestuurslid / programmamanager dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47c1362b00419b642796f8dbdb277a66')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'omschrijving')) == null) {
    (function (message) { alert(message) })('Omschrijving dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7df4667cb7e498668f38074ccb54a3f')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'aantaldagen')) == null) {
    (function (message) { alert(message) })('Omschrijving dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b1be4fde9439f4fbdb1782ed6cc4be2')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'voorzittervergadering')) == null) {
    (function (message) { alert(message) })('U dient aan te geven of u de voorzitter was van de vergadering.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'file')) != null && (getObjectProperty(___arguments.context.pageData, 'bedraginput')) == null) {
    (function (message) { alert(message) })('U heeft een bijlage toegevoegd, vul het bedrag in.');
  } else {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL' && (getObjectProperty(___arguments.context.pageData, 'subsidie')) == 'ZSD') {
      uurtarief = 1200000;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'ZSD') {
      uurtarief = 1200000;
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NCZSD') {
      uurtarief = 1200000;
    } else {
      uurtarief = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tariefuur'));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Thuiswerkregeling' || (getObjectProperty(___arguments.context.pageData, 'soort')) == 'Thuiswerken') {
      bedraginput = (getObjectProperty(___arguments.context.pageData, 'aantaldagen')) * 2.4;
    } else {
      bedraginput = (getObjectProperty(___arguments.context.pageData, 'bedraginput'));
    }
    timestamp = ((new Date()).valueOf());
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaraties').save( ({ [`aantaldagen`]: (getObjectProperty(___arguments.context.pageData, 'aantaldagen')),[`aanmaakdatum`]: (new Date(timestamp)),[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: (getObjectProperty(___arguments.context.pageData, 'soort')),[`uren`]: (getObjectProperty(___arguments.context.pageData, 'uren')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometers')),[`bedraginput`]: bedraginput,[`betreft`]: (getObjectProperty(___arguments.context.pageData, 'betreft')),[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`netwerknaam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerknaamnaam')),[`btw`]: 0,[`tariefkm`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tariefkm')),[`tariefuur`]: uurtarief,[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: 'TE CONTROLEREN',[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`naambestuurslidprogrammamanager`]: (getObjectProperty(___arguments.context.pageData, 'naambestuurslidprogrammamanager')),[`invoer`]: 'declaratie',[`subsidie`]: (getObjectProperty(___arguments.context.pageData, 'subsidie')),[`voorzittervergadering`]: (getObjectProperty(___arguments.context.pageData, 'voorzittervergadering')) }) ));
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NCZSD') {
      ___arguments.context.pageData['subsidie'] = null;
    }
    ___arguments.context.pageData['datum'] = null;
    ___arguments.context.pageData['soort'] = null;
    ___arguments.context.pageData['betreft'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    ___arguments.context.pageData['uren'] = null;
    ___arguments.context.pageData['kilometers'] = null;
    ___arguments.context.pageData['aantaldagen'] = null;
    ___arguments.context.pageData['ovparkeerbedrag'] = null;
    ___arguments.context.pageData['naambestuurslidprogrammamanager'] = null;
    ___arguments.context.pageData['paramuren'] = null;
    ___arguments.context.pageData['voorzittervergadering'] = null;
    ___arguments.context.pageData['paramkilometers'] = null;
    ___arguments.context.pageData['parambedrag'] = null;
    ___arguments.context.pageData['parambetreft'] = null;
    ___arguments.context.pageData['paramomschrijving'] = null;
    ___arguments.context.pageData['file'] = null;
    ___arguments.context.pageData['disablesave'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3342df5cf51474ded7e42463ff683bb6');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',[(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getMonth()) + 1,'-',(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getFullYear())].join(''),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/3342df5cf51474ded7e42463ff683bb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambedrag')) == true ? ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden' ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 5000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3342df5cf51474ded7e42463ff683bb6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/b63dd5617c0b802d3b6bdfffa8171afa/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/24c59afc9b7869a85ebbcb3dbd4e1823/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == null) {
    await Backendless.Data.of('declaraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''))).setSortBy('declaratienummer DESC').setPageSize(100))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == false) {
    await Backendless.Data.of('declaraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''))).setSortBy('declaratienummer DESC').setPageSize(100))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true) {
    await Backendless.Data.of('declaraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': false }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''))).setSortBy('declaratienummer DESC').setPageSize(100))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) != 'AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/8fba7ccc73ad762eb6036605780f2255/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Alleen werktijd' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd' ? false : true)))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'uren')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'uren'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/0af2e266604f9143f7cae657d88abcdc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/cdc6c82bd72ed8df431d68254ec75002/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Voorgeschoten kleine uitgaven' ? false : true))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalc')) == 0) {
    euro = '-';
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalc'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/0a9a0e7fc609f0536cd4851d2431f799/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Alleen werktijd' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd' ? true : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('declaraties').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/8d349db77ecb28f4320418027913049c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? true : false) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('declaraties').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/e1584521a9f12d5e7fa6bcceefb3de9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Voorgeschoten kleine uitgaven' ? true : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('declaraties').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/5cc10345685b54b6e559aa9e945fa2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/3466f6d2e332d4470ba847ba5d5bcb4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d032df632a81c08ddb540411b2af486a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/b17a9c5be42f40f4f4c4a2d438825853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'fileref': (getObjectProperty(___arguments.context.pageData, 'file')),'file': (getObjectProperty(___arguments.context.pageData, 'file')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',[(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getMonth()) + 1,'-',(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getFullYear())].join(''),'\''].join(''))).setSortBy('declaratienummer DESC').setPageSize(100))));
  if ((getObjectProperty(___arguments.context.pageData, 'oldfileref')) != null) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'oldfileref'))));
  }
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('b17a9c5be42f40f4f4c4a2d438825853');

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  ['onBeforeUpload'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['oldfileref'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'));

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 5000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('b17a9c5be42f40f4f4c4a2d438825853');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/5736d87b0cd63d924988b453b0dd4c35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('declaraties').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'objectId')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',[(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getMonth()) + 1,'-',(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getFullYear())].join(''),'\''].join(''))).setSortBy('declaratienummer DESC').setPageSize(10))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/d6ab1a010ef99e6a2728f9ec9fd2249c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')), ({ 'change': false }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/7e1d1f9b5be6b9bbd598d25cfc3894eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramuren')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/7c71c458d1922ed689458c72733c97d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramuren')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/35ef105247f61d7940db483b9e5c93c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramkilometers')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/422ff6fcd0f10f14ff75eb4fe3472b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramkilometers')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    text = 'Reiskosten eigen vervoer worden vergoed á € 0,31 per kilometer. Registreer de kilometers vanaf postcode vertrek to postcode aankomst.';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    text = 'Reiskosten eigen vervoer worden vergoed á €0,31 per kilometer. Vul hieronder het totaal aantal kilometers in (postcode vertrek tot postcode aankomst en retour). Geef bij de omschrijving de plaatsnamen of postcodes van vertrek en aankomst weer.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/1e911222da8da8ae912247b336be6da3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramkilometers')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/737afb2ce06aeace44f69e0c7f161d38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambedrag')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'bedragtitel'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/3ebc7c4270cd4075baf7c12551d219a4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambedrag')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/26c59bb4ac7ebe6a0423b54b2c2e99db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambedrag')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onReadOnlyStateAssignment */
  onReadOnlyStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden' ? true : false)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var parameters;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['sorteer'] = 'datum';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    ___arguments.context.pageData['subsidie'] = 'DNN';
    ___arguments.context.pageData['soort'] = 'Vaste vacatiegelden';
    ___arguments.context.pageData['uren'] = null;
    ___arguments.context.pageData['kilometers'] = null;
    ___arguments.context.pageData['bedraginput'] = null;
    ___arguments.context.pageData['betreft'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    parameters = (await Promise.all((await Backendless.Data.of('soort').find(Backendless.DataQueryBuilder.create().setWhereClause((['soort=\'',(getObjectProperty(___arguments.context.pageData, 'soort')),'\''].join(''))).setPageSize(100))).map(async parameters => {; return ({ [`uren`]: (getObjectProperty(parameters, 'auren')),[`kilometers`]: (getObjectProperty(parameters, 'akilometers')),[`bedrag`]: (getObjectProperty(parameters, 'abedrag')),[`betreft`]: (getObjectProperty(parameters, 'abetreft')),[`omschrijving`]: (getObjectProperty(parameters, 'aomschrijving')),[`bedragtitel`]: (getObjectProperty(parameters, 'bedragtitel')),[`bedragomschrijving`]: (getObjectProperty(parameters, 'bedragomschrijving')) });})))[0];
    ___arguments.context.pageData['paramuren'] = (getObjectProperty(parameters, 'uren'));
    ___arguments.context.pageData['paramkilometers'] = (getObjectProperty(parameters, 'kilometers'));
    ___arguments.context.pageData['parambedrag'] = (getObjectProperty(parameters, 'bedrag'));
    ___arguments.context.pageData['parambetreft'] = (getObjectProperty(parameters, 'betreft'));
    ___arguments.context.pageData['paramomschrijving'] = (getObjectProperty(parameters, 'omschrijving'));
    ___arguments.context.pageData['bedragtitel'] = (getObjectProperty(parameters, 'bedragtitel'));
    ___arguments.context.pageData['bedragomschrijving'] = (getObjectProperty(parameters, 'bedragomschrijving'));
    if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden') {
      ___arguments.context.pageData['bedraginput'] = 200;
    } else {
      ___arguments.context.pageData['bedraginput'] = null;
      ___arguments.context.pageData['uren'] = null;
      ___arguments.context.pageData['kilometers'] = null;
    }
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'ZSD') {
    ___arguments.context.pageData['subsidie'] = 'ZSD';
    ___arguments.context.pageData['soort'] = null;
    ___arguments.context.pageData['uren'] = null;
    ___arguments.context.pageData['kilometers'] = null;
    ___arguments.context.pageData['bedraginput'] = null;
    ___arguments.context.pageData['betreft'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    parameters = (await Promise.all((await Backendless.Data.of('soort').find(Backendless.DataQueryBuilder.create().setWhereClause((['soort=\'',(getObjectProperty(___arguments.context.pageData, 'soort')),'\''].join(''))).setPageSize(100))).map(async parameters => {; return ({ [`uren`]: (getObjectProperty(parameters, 'auren')),[`kilometers`]: (getObjectProperty(parameters, 'akilometers')),[`bedrag`]: (getObjectProperty(parameters, 'abedrag')),[`betreft`]: (getObjectProperty(parameters, 'abetreft')),[`omschrijving`]: (getObjectProperty(parameters, 'aomschrijving')),[`bedragtitel`]: (getObjectProperty(parameters, 'bedragtitel')),[`bedragomschrijving`]: (getObjectProperty(parameters, 'bedragomschrijving')) });})))[0];
    ___arguments.context.pageData['paramuren'] = (getObjectProperty(parameters, 'uren'));
    ___arguments.context.pageData['paramkilometers'] = (getObjectProperty(parameters, 'kilometers'));
    ___arguments.context.pageData['parambedrag'] = (getObjectProperty(parameters, 'bedrag'));
    ___arguments.context.pageData['parambetreft'] = (getObjectProperty(parameters, 'betreft'));
    ___arguments.context.pageData['paramomschrijving'] = (getObjectProperty(parameters, 'omschrijving'));
    ___arguments.context.pageData['bedragtitel'] = (getObjectProperty(parameters, 'bedragtitel'));
    ___arguments.context.pageData['bedragomschrijving'] = (getObjectProperty(parameters, 'bedragomschrijving'));
    if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden') {
      ___arguments.context.pageData['bedraginput'] = 200;
    } else {
      ___arguments.context.pageData['bedraginput'] = null;
      ___arguments.context.pageData['uren'] = null;
      ___arguments.context.pageData['kilometers'] = null;
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/f992a0fc4606d7ce4a22b8a29a4866db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag')) == 0) {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/646c72c5b7de6d7edd5b6d39fc94eb67/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('betreft').find(Backendless.DataQueryBuilder.create().setWhereClause((['soort =\'',(getObjectProperty(___arguments.context.pageData, 'soort')),'\' AND subsidie LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'subsidie')),'%\' AND rol LIKE\'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),'%\''].join(''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'betreft')),'label': (getObjectProperty(item, 'betreft')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambetreft')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/c0db2867755bfb151826ec8960d8422c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambetreft')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/c3e7843e2aaa037673a359271e2e32c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramomschrijving')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/47c1362b00419b642796f8dbdb277a66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramomschrijving')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/6658af14ef125f3b1da798ee92c85184/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('declaraties').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/fbcb0639f0a88b6106985c5ea3916098/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/18953fe3a81a74c78e69969f4071bd05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/3001d1e1a958124ba0de2cd220f4d377/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/5b3fa13d070569f12ed78309cb7552ba/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/51a5e2c995e278451bb775e31761083d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'betreft')) == 'Bovenregionale overleggen' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/52048d8528aa762cc2b47b9c6f557476/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'betreft')) == 'Bovenregionale overleggen' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/81f163647e09f40599a67bce439df575/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'declaratienummer')),'\''].join('')), ({ 'file': null,'fileref': null }) );
  (function (message) { alert(message) })('De bijlage is verwijderd.');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''))).setSortBy('declaratienummer DESC').setPageSize(100))));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/07c881861aa51d835abd61c7d8a92dbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/6687a75c724c5d3d5a6b9a1c0be8a2ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/73943b7ccd73fc9b0fd8b55734196595/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'ZSD') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NCZSD') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/93bcca9d573c69a789f4e01a016dbf16/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'ZSD') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NCZSD') {
    visible = true;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['soort'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/ec1d19a33c7ed844a6e550f9434ac044/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'subsidie')) == 'DNN') {
    text = 'Professionalisering';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'subsidie')) == 'ZSD') {
    text = 'ZSD';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/bef402a175097ed36e889c441fec93d5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Thuiswerkregeling' || (getObjectProperty(___arguments.context.pageData, 'soort')) == 'Thuiswerken')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/b7df4667cb7e498668f38074ccb54a3f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Thuiswerkregeling' || (getObjectProperty(___arguments.context.pageData, 'soort')) == 'Thuiswerken')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/0b1be4fde9439f4fbdb1782ed6cc4be2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL' && (getObjectProperty(___arguments.context.pageData, 'voorzittervergadering')) == 'Ja') {
    ___arguments.context.pageData['bedraginput'] = 468.82;
  } else if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL' && (getObjectProperty(___arguments.context.pageData, 'voorzittervergadering')) == 'Nee') {
    ___arguments.context.pageData['bedraginput'] = 360.63;
  } else {
    ___arguments.context.pageData['bedraginput'] = null;
    ___arguments.context.pageData['uren'] = null;
    ___arguments.context.pageData['kilometers'] = null;
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/c7cfe3324fe1d25b5ffa808425485bda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/09e1176c637700e74e414a53b0b501e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/76fc11df78b702ff5ae8c7c65563e2fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''))).setSortBy((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))).setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnndeclaratiesindienen/components/b2c935f216085692a30788fa699be4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnexports/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriodnnbhrlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriomasterbhrjm')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnnexports/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('bestuurslid')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabestuurslid', undefined);
  } else if (((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnexports/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('bestuurslid')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabestuurslid', undefined);
  } else if (((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnexports/components/71bb8c0f36a703f62f7844d46b446c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvuserstotaaloverzicht;


  csvuserstotaaloverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/userstotaaloverzichtdnn.csv','tableName': 'Users','tableOptions': ({ [`where`]: 'organisatie<>\'Lorio\'',[`relations`]: undefined,[`groupBy`]: undefined,[`sortBy`]: 'naam ASC',[`pageSize`]: 200,[`properties`]: ['dashboardnaam', 'naam', 'organisatie'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dashboardnaam', 'naam', 'organisatie'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvuserstotaaloverzicht, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnexports/components/92366036afeedee8b25f984674c36d95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvbtwinstellingentotaaloverzicht;


  csvbtwinstellingentotaaloverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/btwinstellingendnn.csv','tableName': 'Users','tableOptions': ({ [`where`]: 'organisatie<>\'Lorio\'',[`relations`]: undefined,[`groupBy`]: undefined,[`sortBy`]: 'naam ASC',[`pageSize`]: 200,[`properties`]: ['naam', 'rol', 'organisatie', 'btwplichtig'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['naam', 'rol', 'organisatie', 'btwplichtig'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvbtwinstellingentotaaloverzicht, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnexports/components/aabc5f659a96e6485db59c21c50fb13f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvgooglestudiodatadnn;


  csvgooglestudiodatadnn = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvgooglestudiodatadnn.csv','tableName': 'declaraties','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`sortBy`]: undefined,[`pageSize`]: 100000,[`properties`]: ['aanmaakdatum', 'aanmaakdatumaanpassing', 'aanmaakdatumform', 'aanmaakjaar', 'aanmaakmaand', 'aanmaakmaandnum', 'bedragcalc', 'bedragcalcbtw', 'bedragcalctotaal', 'bedraginput', 'betreft', 'bijlage', 'btw', 'btwplichtig', 'controle', 'controledatum', 'controledatum', 'controledatum', 'controleemailverzonden', 'controlereden', 'dashboardnaam', 'datum', 'datumdeclaratie', 'declaratienummer', 'invoer', 'kilometers', 'kmbtw', 'kmexbtw', 'kmtotaal', 'kostenplaats', 'maand', 'maandakkoord', 'maandakkoordmail', 'naambestuurslidprogrammamanager', 'omschrijving', 'rol', 'soort', 'tariefkm', 'tariefuur', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'uren', 'urenbtw', 'urenexbtw', 'urentotaal', 'dashboardnaam', 'objectId', 'ownerId', 'created', 'updated', 'subsidie'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['aanmaakdatum', 'aanmaakdatumaanpassing', 'aanmaakdatumform', 'aanmaakjaar', 'aanmaakmaand', 'aanmaakmaandnum', 'bedragcalc', 'bedragcalcbtw', 'bedragcalctotaal', 'bedraginput', 'betreft', 'bijlage', 'btw', 'btwplichtig', 'controle', 'controledatum', 'controledatum', 'controledatum', 'controleemailverzonden', 'controlereden', 'dashboardnaam', 'datum', 'datumdeclaratie', 'declaratienummer', 'invoer', 'kilometers', 'kmbtw', 'kmexbtw', 'kmtotaal', 'kostenplaats', 'maand', 'maandakkoord', 'maandakkoordmail', 'naambestuurslidprogrammamanager', 'omschrijving', 'rol', 'soort', 'tariefkm', 'tariefuur', 'totaalbedrag', 'totaalbtw', 'totaalexbtw', 'uren', 'urenbtw', 'urenexbtw', 'urentotaal', 'dashboardnaam', 'objectId', 'ownerId', 'created', 'updated', 'subsidie'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvgooglestudiodatadnn, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnexports/components/f8a8a4e57ea8b818b3252d8fa3370de4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('declaraties').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['controle=\'Akkoord\' AND ','subsidie=\'DNN\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnexports/components/54284ccfe4087eb85fc366787f524788/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dcb1f218965854dbe058b338fe6815f9', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['controle=\'AKKOORD\' AND ','subsidie=\'DNN\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('07180b58a428e9f8947200748ad88248', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['controle=\'AKKOORD\' AND ','subsidie=\'ZSD\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd48bd73e559b8de36e802184a68bcd8', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['controle=\'AKKOORD\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnexports/components/dcb1f218965854dbe058b338fe6815f9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('dcb1f218965854dbe058b338fe6815f9', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['controle=\'AKKOORD\' AND ','subsidie=\'DNN\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnexports/components/4048664c4068d24623b475a871b89165/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnexports/components/b6b892cc208c1f323c482b18ed485e4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('declaraties').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['controle=\'Akkoord\' AND ','subsidie=\'ZSD\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnexports/components/07180b58a428e9f8947200748ad88248/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('07180b58a428e9f8947200748ad88248', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['controle=\'AKKOORD\' AND ','subsidie=\'ZSD\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnexports/components/cd48bd73e559b8de36e802184a68bcd8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd48bd73e559b8de36e802184a68bcd8', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['controle=\'AKKOORD\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties('Sum (datatotaalbedrag) as totaal').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnexports/components/ce48e328c16416d8e94801f8e479117e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Backendless.Data.of('declaraties').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['controle=\'Akkoord\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnexports/components/fc04b9dd6d481ffad21d20b87b51e538/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnexports/components/f2d1e3c8168b662810f6a648b2e8df88/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.dataModel, 'totaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnexports/components/3fb5d218b588d8bf0d1396ecd6081768/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Data.of('declaraties').getObjectCount())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriodnnbhrlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriodnnbhrjm')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ae9330cf0d1e6e61dffad9e359f0f65', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/a6ddb20388c34e97afd58d61b4165803/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = true;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setProperties('aanmaakmaand').setSortBy('aanmaakdatum ASC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakmaand')),'label': (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/59e66456051b2e07f5a8a6aaea5e262d/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Declaraties ingevoerd in de maand ') + String(getObjectProperty(___arguments.context.pageData, 'maandselectie')))

  },
  /* handler:onTitleAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/cee870e278bab351e4e5e747df4804f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'urenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/cf1c1b3221568c0946c1d907028d066e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'urenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/8ebb9d5e038941ceebe84b8b9c52064b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'urentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/e5f121045216195374a7825655bcdf27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/f88d1bea5317b02b3455607a7d93046c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/f339fed4b0092e5741361a26aafd6479/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/8d57763628b2680464b48b5f08d2c897/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'tariefuur'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/825eed757945b00fcf1397ec25ca037a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'tariefkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/442a8d859c447ed5ece2ad715a94104c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/ee6ffde4e713391cdd28da05ff492cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/88c9da9a0d241e180ee2bebf415cc292/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/c5c88dbff2e78f5d95794b6cf07d8592/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d43c6b8afbc312e1924dadb3ab21106'), 'ovparkeerbedragcalc'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/b43128b24b58cfa98f6c86e90449fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b43128b24b58cfa98f6c86e90449fbfa', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/0083293170ed7a7905189a83ba718e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'maandakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('abcea5b23c64a28ca1d9da04bd6c20ce', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c5154d961793335d49745767ba37dbd1', false);
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c5154d961793335d49745767ba37dbd1', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('abcea5b23c64a28ca1d9da04bd6c20ce', false);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/0ae9330cf0d1e6e61dffad9e359f0f65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/f2b8655d760b784883b545b5e2c60f9c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/759ff4ee989244a40dd78fe5ff77b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/8d182e157fa1e64dca945f6317ca70a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/d6178944b80b64b723d3b11e10ff1293/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/1125d9932312ea771ac93dd183f36eda/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7ab83b82ac3768c0cfdda15bd3f324'), 'tariefuur'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/e014725de6ecc1dcb53e4ed4c5b3bd7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4ff6009bcc925edb5b52809ffa24444'), 'tariefkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/712a5a17a1bd109ecbd5dc34e531671f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7ab83b82ac3768c0cfdda15bd3f324'), 'urenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/493f4482bdf325e12a0788a63488ecd4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4ff6009bcc925edb5b52809ffa24444'), 'kmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/8cc4a2eccce15f524dcc8a773c36097c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7ab83b82ac3768c0cfdda15bd3f324'), 'urenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/cd3a204480a62ddb672bc5310f29273e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4ff6009bcc925edb5b52809ffa24444'), 'kmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/2b3d088d5fff0be64bfbc82ce2d1bf53/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4b7ab83b82ac3768c0cfdda15bd3f324'), 'urentotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/d698d86aaae816b679941b58e78ad6f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d4ff6009bcc925edb5b52809ffa24444'), 'kmtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/23a34b01b91844fa0b4e6ee1ab463b7a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f7041bfb863cfd740c1b8adf60b2dfb5'), 'ovparkeerbedragcalc'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/3818a2bb7227548bd708113a6e7224a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f3c68745b8d48e615e22eadde0e3af9'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/3f334a61903a7539d02c5303beec4805/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f3c68745b8d48e615e22eadde0e3af9'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/a5ef62bbf7ba1e0ef904e7fd6c4bc06c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8f3c68745b8d48e615e22eadde0e3af9'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/deee0a06623c9e44e6e9ebe96dc916ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deee0a06623c9e44e6e9ebe96dc916ce', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/0d3e958c47d525ca4ee375b67884f1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/84e654d127f5ef097d548db1f876e12a/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('84e654d127f5ef097d548db1f876e12a', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['betreft', 'Sum(uren) as uren', 'tariefuur', 'Sum(urenexbtw) as urenexbtw', 'Sum(urenbtw) as urenbtw', 'Sum(urentotaal) as urentotaal']).setSortBy('betreft').setGroupBy('betreft').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/61b5e6d31a9a11fa38977d07b0391486/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('61b5e6d31a9a11fa38977d07b0391486', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['betreft', 'Sum(kilometers) as kilometers', 'tariefkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/cb5d1d75b46280cbd5f5795c98ac34bb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cb5d1d75b46280cbd5f5795c98ac34bb', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('Sum(ovparkeerbedragcalc) as ovparkeerbedragcalc').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/22bfcf123de2d3a235778195c10d7c04/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22bfcf123de2d3a235778195c10d7c04', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/d31cb031efe92bcef27dd30c166debe9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/7acd8669688de30b25f548a20e3934aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/2da62ab21281ef0706b209e5fa7ef6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2da62ab21281ef0706b209e5fa7ef6b5', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/9a07a37569c9d2f84437f1ab9add098d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/86e2eaaf2781f02ae9f8344f58a9ffe3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/29b1b26478246886942dcd297b5ff4f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/4fd709b151d62e041a7c3481ece40e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/e61c2ef961933bdcbb89393d96a6b1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/38288ef8776bacfe3338d7249f0c36ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/2a3cbc427f488c8af2774fb1ca7eff3b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/bfc81f8d0c18cd3d7b0b509254658aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/b8e19287595e585e05e5f51a47798d7d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/4b671b666ea23d6388abf866da9a5265/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/61a65531664f912f78b27e6f3c9e4d98/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('username').setSortBy('username ASC').setGroupBy('username').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'username')),'label': (getObjectProperty(item, 'username')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['user'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/4769cb26e35c0751f0b8e21caf486471/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2a3cbc427f488c8af2774fb1ca7eff3b', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['betreft', 'Sum(uren) as uren', 'tariefuur', 'Sum(urenexbtw) as urenexbtw', 'Sum(urenbtw) as urenbtw', 'Sum(urentotaal) as urentotaal']).setSortBy('betreft').setGroupBy('betreft').setPageSize(100))));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfc81f8d0c18cd3d7b0b509254658aea', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['betreft', 'Sum(kilometers) as kilometers', 'tariefkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setPageSize(100))));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b8e19287595e585e05e5f51a47798d7d', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('Sum(ovparkeerbedragcalc) as ovparkeerbedragcalc').setPageSize(100))));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b671b666ea23d6388abf866da9a5265', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2b8655d760b784883b545b5e2c60f9c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('maandakkoord').setGroupBy('maandakkoord').setPageSize(100))));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('07ced1bd5dd517aa2c8c817a55c4e3ff', (await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\''].join(''))).setProperties(['naam', 'organisatie', 'email']).setPageSize(100))));
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty(___arguments.context.pageData, 'user')),'\'','AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''));
  ___arguments.context.pageData['INVOICE'] = true;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnfacturenversturen/components/07ced1bd5dd517aa2c8c817a55c4e3ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/dd2ac4efbecb1abe55a608d2323a9f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dcd100a43f8da29832aea72b61d49cc')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', true);
  }
  ___arguments.context.pageData['btwplichtig'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/bfad8b5160a8b3e6253374a4c7ba2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/0ab633ae17a6e5765fa8cd8a0fd2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('userdeactiveren', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'username')),[`naamuser`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'organisatie')) }), undefined);
  await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aangemelddooremail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'Aanvraag tot deactiveren',[`naam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'organisatie')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'username')) }) );
  (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),' is verzonden. Wij zullen deze gebruiker zo snel mogelijk op inactief zetten. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/87b21c497cf55673c52611530531b85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'userStatus')) == 'ENABLED' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/7836af74b96eaf0fc8f1b77d91fd4125/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND GV LIKE \'GV%\''].join(''))).setProperties('dashboardnaam').setSortBy('dashboardnaam ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dashboardnaam')),'label': (getObjectProperty(item, 'dashboardnaam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/38b45228c9ab1108f4319b04e5df558f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f24bb6b6ee8444046dfd4b245e7a6503')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/d0ab53412e941c4725f9135d79ebe1ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dashboardnaam')) == null) {
    (function (message) { alert(message) })('Er is geen dashboardnaam geselecteerd.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('dashboardnaamopvragen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'regiogv': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'centraname': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dashboardnaam': (getObjectProperty(___arguments.context.pageData, 'dashboardnaam')) }), undefined);
    (function (message) { alert(message) })('Het verzoek is verzonden. U ontvangt zo snel mogelijk bericht.');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/4ecb878544048e22f147a48a121282aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'rol')) == null) {
    (function (message) { alert(message) })('De rol dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'organisatie')) == null) {
    (function (message) { alert(message) })('De organisatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cea9d95123a6fa28106de5a1f4875142')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'btwplichtig')) == null) {
    (function (message) { alert(message) })('De btw plicht dient ingevuld te worden');
  } else {
    await Backendless.Data.of('newuserrequests').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aangemelddooremail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`btwplichtig`]: (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),[`rol`]: (getObjectProperty(___arguments.context.pageData, 'rol')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('newuseraanmelding', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamnewuser`]: (getObjectProperty(___arguments.context.pageData, 'naam')) }), undefined);
    (function (message) { alert(message) })('De gebruiker is aangemeld. Wij zullen zo snel mogelijk een account voor de gebruiker aanmaken en hem of haar een mail sturen met de benodigde informatie.');
    await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`rol`]: (getObjectProperty(___arguments.context.pageData, 'rol')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`btwplichtig`]: (getObjectProperty(___arguments.context.pageData, 'btwplichtig')) }) );
    ___arguments.context.pageData['rol'] = null;
    ___arguments.context.pageData['naam'] = null;
    ___arguments.context.pageData['email'] = null;
    ___arguments.context.pageData['organisatie'] = null;
    ___arguments.context.pageData['btwplichtig'] = false;
    ___arguments.context.pageData['btwplichtigselect'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('2b98b3d893885cadd258a833d6983e58');
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/85afad1323a559a247c7d27e5a26e7c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == true) {
    ___arguments.context.pageData['btwplichtig'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == false) {
    ___arguments.context.pageData['btwplichtig'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (String('userStatus=\'ENABLED\' AND') + String(' organisatie<>\'Lorio\'')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'naam', 'organisatie', 'rol', 'username', 'userStatus', 'lastLogin', 'btwplichtig'] })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/e031c83c1f6df2a433fe0185674839c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plgegevensgv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/736c89422ff2f8161ec73926b835933d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/cea9d95123a6fa28106de5a1f4875142/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/30e35eb2b337e024f2ba6312b8eaddcc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'naam', 'organisatie', 'rol', 'username', 'userStatus', 'lastLogin'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/187bbb778f8fa873a2435f2662487913/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'naam', 'organisatie', 'rol', 'username', 'userStatus', 'lastLogin'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/84a3b24178d6b4bcf1f651b7cd1ac09e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'lastLogin', 'naam', 'organisatie', 'rol', 'username', 'userStatus'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/150f3c052d4dabfe0a46633d17978dc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin')) == null) {
    text = null;
  } else {
    text = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/1f3facfbe3b217cf84ed976b90f8505f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'NC') {
    ___arguments.context.pageData['btwplichtig'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnngebruikersbeheer/components/2b98b3d893885cadd258a833d6983e58/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
      return 'useraangemaakt = 0'

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/dd2ac4efbecb1abe55a608d2323a9f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dcd100a43f8da29832aea72b61d49cc')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/bfad8b5160a8b3e6253374a4c7ba2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/0ab633ae17a6e5765fa8cd8a0fd2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('userdeactiveren', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'username')),[`naamuser`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'organisatie')) }), undefined);
  await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aangemelddooremail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'Aanvraag tot deactiveren',[`naam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'organisatie')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'username')) }) );
  (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),' is verzonden. Wij zullen deze gebruiker zo snel mogelijk op inactief zetten. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/87b21c497cf55673c52611530531b85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'userStatus')) == 'ENABLED' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/7836af74b96eaf0fc8f1b77d91fd4125/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['centraname=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\'',' AND GV LIKE \'GV%\''].join(''))).setProperties('dashboardnaam').setSortBy('dashboardnaam ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'dashboardnaam')),'label': (getObjectProperty(item, 'dashboardnaam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/38b45228c9ab1108f4319b04e5df558f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f24bb6b6ee8444046dfd4b245e7a6503')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/d0ab53412e941c4725f9135d79ebe1ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dashboardnaam')) == null) {
    (function (message) { alert(message) })('Er is geen dashboardnaam geselecteerd.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('dashboardnaamopvragen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'regiogv': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regiogv')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'centraname': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'dashboardnaam': (getObjectProperty(___arguments.context.pageData, 'dashboardnaam')) }), undefined);
    (function (message) { alert(message) })('Het verzoek is verzonden. U ontvangt zo snel mogelijk bericht.');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f24bb6b6ee8444046dfd4b245e7a6503', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/4ecb878544048e22f147a48a121282aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'gv')) == null) {
    (function (message) { alert(message) })('De rol dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'organisatie')) == null) {
    (function (message) { alert(message) })('De organisatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e0972e5824ad68dc30fb528fe7d2eb9a')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'regiogv')) == null) {
    (function (message) { alert(message) })('De regio dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtig')) == null) {
    (function (message) { alert(message) })('De btw plicht dient ingevuld te worden');
  } else {
    await Backendless.Data.of('newuserrequests').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aangemelddooremail`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`btwplichtig`]: (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),[`rol`]: (getObjectProperty(___arguments.context.pageData, 'rol')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('newuseraanmelding', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamnewuser`]: (getObjectProperty(___arguments.context.pageData, 'naam')) }), undefined);
    (function (message) { alert(message) })('De gebruiker is aangemeld. Wij zullen zo snel mogelijk een account voor de gebruiker aanmaken en hem of haar een mail sturen met de benodigde informatie.');
    ___arguments.context.pageData['gv'] = null;
    ___arguments.context.pageData['naam'] = null;
    ___arguments.context.pageData['email'] = null;
    ___arguments.context.pageData['organisatie'] = null;
    ___arguments.context.pageData['regiogv'] = null;
    ___arguments.context.pageData['btwplichtig'] = false;
    ___arguments.context.pageData['btwplichtigselect'] = false;
    ___arguments.context.pageData['btwinclconsulten'] = false;
    ___arguments.context.pageData['btwinclconsultenselect'] = false;
    ___arguments.context.pageData['btwinclgroepsconsulten'] = false;
    ___arguments.context.pageData['btwinclgroepsconsultenselect'] = false;
    ___arguments.context.pageData['btwinclmdopatz'] = false;
    ___arguments.context.pageData['btwinclmdopatzselect'] = false;
    ___arguments.context.pageData['btwinclscholing'] = false;
    ___arguments.context.pageData['btwinclscholingselect'] = false;
    ___arguments.context.pageData['btwinclcoaching'] = false;
    ___arguments.context.pageData['btwinclcoachingselect'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('ee881636b2d80ea8aa28e3ea9ff8d688');
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/e0972e5824ad68dc30fb528fe7d2eb9a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\''].join(''))).setProperties('regio').setSortBy('regio ASC').setGroupBy('regio').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'regio')),'label': (getObjectProperty(item, 'regio')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/85afad1323a559a247c7d27e5a26e7c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == true) {
    ___arguments.context.pageData['btwplichtig'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == false) {
    ___arguments.context.pageData['btwplichtig'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn73mwn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['userStatus=\'ENABLED\' AND',' organisatie<>\'Lorio\' AND rol=\'ZSD\' OR ','userStatus=\'ENABLED\' AND',' organisatie<>\'Lorio\' AND rol=\'NCZSD\' '].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'naam', 'organisatie', 'rol', 'username', 'userStatus'] })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/e031c83c1f6df2a433fe0185674839c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('plgegevensgv', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Gelderland') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')) == 'Willem') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/736c89422ff2f8161ec73926b835933d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/cea9d95123a6fa28106de5a1f4875142/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/30e35eb2b337e024f2ba6312b8eaddcc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\' AND subsidie=\'ZSD\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'naam', 'organisatie', 'rol', 'username', 'userStatus'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/187bbb778f8fa873a2435f2662487913/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\' AND subsidie=\'ZSD\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'naam', 'organisatie', 'rol', 'username', 'userStatus'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/84a3b24178d6b4bcf1f651b7cd1ac09e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\' AND subsidie=\'ZSD\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'naam', 'organisatie', 'rol', 'username', 'userStatus'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnngebruikersbeheerzsd/components/ee881636b2d80ea8aa28e3ea9ff8d688/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
      return 'useraangemaakt = 0'

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/dnnhelpdesk/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnnhelpdesk/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('bestuurslid')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabestuurslid', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhelpdesk/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('bestuurslid')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabestuurslid', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhelpdesk/components/71bb8c0f36a703f62f7844d46b446c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('helpdesk', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`userrole`]: (await Backendless.UserService.getUserRoles()),[`vraag`]: (getObjectProperty(___arguments.context.pageData, 'email')) }), undefined);
  ___arguments.context.pageData['email'] = 'DE EMAIL IS VERZONDEN';
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/f31b933c0e69f802cc5299a92202b409/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['naam'])

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/009eb394bb26fa4954be5e1c790af8d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['username'])

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/3144150ac571e5e7286c2d8fede7e428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/b4e8b57329ba9b3c520c9c2433d24fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnmaandcontrole', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/a92d207ac0d9adedfcb30a7f9bdfe5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhelpdesk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/525d3c3e9ae354e50069c3388b04f3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnmaandakkoord', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/791bac21cfa845f34949e23f3dce27df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnfacturenversturen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/b1552a32f7853c686a04402fd58dcf95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnbetalingsgegevens', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/d67679b1777452a711e651637bd9448f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnprojectkosten', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/dc487a0270d1da9dc6ff070e36437122/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1wzYfgc2LfszBPAWanZniFnXOdS1rctuW/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/278a396a1a5e4fc3fb0e22fbd9a74619/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/e80bdea8f1f17f9b2e8a8c5a425e7503/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1zjg-c_dRSM0voi6M6jtk8RSG0WrH13e8/view?usp=sharing', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/c592c926c004a7b54db96c55ad58bac3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).indexOf('lorio') !== -1) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnmailsversturen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/b7bf8bec27de7d66ce66bf3b6cd4ea17/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnngebruikersbeheer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/483b6cb5ab2e4c2ad1fcfd216636eccc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnexports', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriodnnbhrlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriomasterbhrjm' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnhoofdpaginabeheerder/components/46783187b988b315a93f7f86ebea2186/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriodnnbhrlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriomasterbhrjm' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('permissions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/f31b933c0e69f802cc5299a92202b409/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['naam'])

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/009eb394bb26fa4954be5e1c790af8d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ((await Backendless.UserService.getCurrentUser(false))['username'])

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/7c3a5ddea1c83568e2b225686267a9a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    name2 = 'Netwerkcoördinator';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    name2 = 'Personeelslid';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    name2 = 'Bestuurslid';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'ZSD') {
    name2 = 'Projectlid';
  }

  return name2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/6129ee532514662eeacc88f4361f32ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/3144150ac571e5e7286c2d8fede7e428/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/b4e8b57329ba9b3c520c9c2433d24fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnndeclaratiesindienen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/525d3c3e9ae354e50069c3388b04f3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnmaandoverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/b1552a32f7853c686a04402fd58dcf95/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnmijngegevens', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`ownerId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/0021ac391567825f0b2fb66f67c5de5a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnmijndeclaraties', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/4a7870b61279d126f4c477f2dc77f1a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhelpdesk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/278a396a1a5e4fc3fb0e22fbd9a74619/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    visible = true;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboard', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/1b84a1e44048d2c8b2d1e4acfc0ffb43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1pKbgWYC2vqGy3yf9Sx0rlbd5EZHd-yqj/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1hCT73kZ7OYJkYvkt-Qrow-g2vGC2UvAL/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1OJ97AbR6DswMD_grmZr9cjN0oI4hx_cr/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'ZSD') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1N71Hu9t55LUpt_Uui2ps2pVzI75_BdCY/edit?usp=share_link&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/5425e6dffac8c46e110ee77b2757eb18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1XuqcuBHYn4R8PaBkFDT1YbZSPzjKKAjA/view?usp=sharing', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'ZSD') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1osIxAEPxfUkR1trSH602NaNWApOWOBkf/view?usp=share_link', true, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1fFuoaLQwd4G4XTyeDH6bppX6PZ0s-9lo/view?usp=sharing', true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/83f601436ddd0be9093f5d0fd3896c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnmaandcontrolezsd', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn73mwn') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnhoofdpaginanetwerkcoordinator/components/4dbbb79bc2bc89ed6e668389e7756d41/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn73mwn') {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnngebruikersbeheerzsd', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filternaam'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7b2d1738387eeb83132702d518878e44', (await Backendless.Data.of('maandafsluiten').find(Backendless.DataQueryBuilder.create().setWhereClause((['maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause('invoer=\'declaratie\'').setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakmaand')),'label': (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/6c98989bb6763daf4ef53737e753e4d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandafsluiten')) == true) {
    (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      await Backendless.Data.of('declaraties').bulkUpdate( (['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'aanmaakmaand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),'\''].join('')), ({ 'maandakkoord': true }) );
      await Backendless.Data.of('historiemaandakkoord').save( ({ 'status': 1,'naamakkoordgever': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumakkoord': (new Date()),'usernamegv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),'naamgv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'naam')),'maand': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'aanmaakmaand')) }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == false) {
      await Backendless.Data.of('declaraties').bulkUpdate( (['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'aanmaakmaand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),'\''].join('')), ({ 'maandakkoord': false }) );
      await Backendless.Data.of('historiemaandakkoord').save( ({ 'status': 0,'naamakkoordgever': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumakkoord': (new Date()),'usernamegv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),'naamgv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'naam')),'maand': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'aanmaakmaand')) }) );
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoordmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('91a638e60d620101fcff5b7fd6d8927d'))['color'] = '#8cc63f';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('91a638e60d620101fcff5b7fd6d8927d'))['color'] = '#545C5C';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/536bf88fa7e15e87091f6692c205d116/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandafsluiten')) == true) {
    (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordalles')) == true) {
      await Backendless.Data.of('declaraties').bulkUpdate( (['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoord`]: true }) );
      await Backendless.Data.of('historiemaandakkoord').save( ({ [`status`]: '1-alles akkoord geven',[`naamakkoordgever`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumakkoord`]: (new Date()),[`usernamegv`]: undefined,[`naamgv`]: undefined,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')) }) );
    } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordalles')) == false) {
      await Backendless.Data.of('declaraties').bulkUpdate( (['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoord`]: false }) );
      await Backendless.Data.of('historiemaandakkoord').save( ({ [`status`]: '0-alles niet akkoord geven',[`naamakkoordgever`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`datumakkoord`]: (new Date()),[`usernamegv`]: undefined,[`naamgv`]: undefined,[`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')) }) );
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle = \'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naambeheerder`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailakkoord')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'username')) }), undefined);
  await Backendless.Data.of('declaraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'username')),'\' ',' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoordmail`]: 1 }) );
  await Backendless.Data.of('historiemaandakkoordmail').save( ({ [`actie`]: 'email naar gebruiker gestuurd voor akkoord voor facturatie',[`door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoordvoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'username')) }) );
  ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailakkoord'] = 'DE EMAIL IS VERZONDEN';
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/514b87df91c87a0759af23ebde228b54/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' afsluiten'].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('De maand moet eerst geselecteerd worden voordat de maand afgesloten kan worden.');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5096d101a367f71e12fd42e14f9e8f05'), 'maandafsluiten')) == true) {
      await Backendless.Data.of('declaraties').bulkUpdate( (['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle <>\'AKKOORD\''].join('')), ({ 'maandakkoord': true }) );
      await Backendless.Data.of('maandafsluiten').bulkUpdate( (['maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandafsluiten': true }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5096d101a367f71e12fd42e14f9e8f05'), 'maandafsluiten')) == false) {
      await Backendless.Data.of('declaraties').bulkUpdate( (['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle <>\'AKKOORD\''].join('')), ({ 'maandakkoord': false }) );
      await Backendless.Data.of('maandafsluiten').bulkUpdate( (['maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandafsluiten': false }) );
    }
    ___arguments.context.pageData['maandafsluiten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5096d101a367f71e12fd42e14f9e8f05'), 'maandafsluiten'));
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriodnnbhrlieke' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriomasterbhrjm' ? false : true))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/06d3309bd70efca3bf74803845f86c1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'  van DNN is akkoord bevonden om te factureren. ','U vindt het maandoverzicht in het declaratiesysteem van DNN (lorio.nl/dnn) onder de knop \'maandoverzicht\'. Selecteer hier de maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),', maak een kwitantie/factuur aan en mail deze aan facturen@dementienetwerknederland.nl \' '].join('');

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/929e3751c3b3eb5b4202c3057fbe5bd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'rol')) == 'NC') {
    text = 'Netwerkcoördinator';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'rol')) == 'BL') {
    text = 'Bestuurslid';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'rol')) == 'PL') {
    text = 'Personeelslid';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'rol')) == 'ZSD') {
    text = 'Netwerkcoördinator';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'VIEW'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/125ec2fc843765ca4a9ef08961082756/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('maandafsluiten', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  (function (message) { alert(message) })('Er is een mail verstuurd naar info@lorio.nl om de maand af te laten sluiten.');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/e64bc08e451606ad73ae4ec24c3dfce4/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandafsluiten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5096d101a367f71e12fd42e14f9e8f05'), 'maandafsluiten'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/17ec9969ac598f823306337236d8dc4c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van het declaratiesysteem van ','Dementie Netwerk Nederland',' is akkoord bevonden om te factureren\'.'].join('');

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/be4d6a5276afb3adad15f75e120837d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = ((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND maandakkoord =1'].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bcc'] = (list.join(','));
  ___arguments.context.pageData['massiveemailakkoord'] = '';
  ___arguments.context.pageData['VIEW'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b2d1738387eeb83132702d518878e44', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('232aeb59198375e9ab215808854263de', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('486afa3e2b92de41b7e375562528915c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('650d2173e2ce120b143855ec7943a6fc', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d96d88dfdef636f9f42767f10e34bc88', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/650d2173e2ce120b143855ec7943a6fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('232aeb59198375e9ab215808854263de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('486afa3e2b92de41b7e375562528915c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b2d1738387eeb83132702d518878e44', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('650d2173e2ce120b143855ec7943a6fc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d96d88dfdef636f9f42767f10e34bc88', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandakkoord/components/ee9bc018724d0da127143773fb938e61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('maandakkoordmassive', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: [(getObjectProperty(___arguments.context.pageData, 'bcc')), 'backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naambeheerder`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailakkoord')) }), undefined);
  await Backendless.Data.of('declaraties').bulkUpdate( (['aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND maandakkoord =1'].join('')), ({ [`maandakkoordmail`]: 1 }) );
  await Backendless.Data.of('historiemaandakkoordmail').save( ({ [`actie`]: 'email naar alle gebruikers gestuurd voor akkoord voor facturatie',[`door`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`akkoordvoor`]: 'Alle gebruikers' }) );
  ___arguments.context.pageData['massiveemailakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('232aeb59198375e9ab215808854263de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('486afa3e2b92de41b7e375562528915c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7b2d1738387eeb83132702d518878e44', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('650d2173e2ce120b143855ec7943a6fc', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d96d88dfdef636f9f42767f10e34bc88', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['sorteer'] = 'aanmaakdatum';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['filtersubsidie'] = '%';
  ___arguments.context.pageData['controleredenselect'] = null;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause('invoer=\'declaratie\'').setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakmaand')),'label': (getObjectProperty(item, 'aanmaakmaand')) });}))), ({ 'value': '%','label': 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('soort').setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'soort')),'label': (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/eeba4f11ff83adb518cd9bf27c2bfdd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/e2c61d87bc58b6e94c2169198c89c24a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/c844a5a1f7dc507f816a71317d32ffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/fd4dd1d1870d13bc8fdc99022b466aa2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'controleaantekeningen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')).length == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ 'aantekening': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumaantekening': (new Date()),'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/e5ec874e8ac1ea4302eda01272f18515/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\' AND datumdeclaratie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/db3ca88257ea87823aaeddfbab489acd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/ea8e5f46728303469314cb096613459d/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/50dd46436e5f16324f9ae3ee4a7d1cc9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefuur'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/2da7cb39be92b6abfddf0885874b3b39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'urenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/7007895980926936a54d76ff730aa0d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'urenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/b0a487118b0b294316a88d199f7392a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'urentotaal')) == 0) {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'urentotaal'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/1342996de18c646808b19b7414077874/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/bd170562f2ababa847212538578864a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/e3ef5e35146312ebcf9840bceeb7a932/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/49175a9f72a9bbab12feb41549060c06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/cde841b5de47cd08a98c3ed4749cd169/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragcalc')) == 0) {
    euro = '-';
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragcalc'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/f844ad9efa7ba454189e0434e6554814/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/3ce8ec9e449489fbef082b640b73e4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/d92a86f1e7649229796ac0de2abd89e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'uren')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'uren'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/268315d13ec1372eb592700dcdbb694a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/78464eddc63154cbc5b7bdf79277f436/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'aanmaakdatumaanpassing': (new Date()),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()),'maandakkoord': true }) );
      await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'aanmaakdatumaanpassing': (new Date()),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()),'maandakkoord': true }) );
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'NIET AKKOORD';
      await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'controle': 'NIET AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'controle': 'NIET AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'TE CONTROLEREN';
      await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'controle': 'TE CONTROLEREN','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'controle': 'TE CONTROLEREN','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
    await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'info': 'declaratie komt van status OPNIEUW INGEDIEND','controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = ' #558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#e0ab0d';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/453f9b73304601bb52a4f3711243ed17/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f178392d6c6346cfff015d5ff2bf7e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('453f9b73304601bb52a4f3711243ed17', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34b8440f1771418f56fc397b6d9edeab', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/316a7eae0b1698e6b2a692072584ffee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var reden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null) {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving'));
  } else {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenselect'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null && (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving')) == null) {
    (function (message) { alert(message) })('Er moet een reden ingegeven worden om deze te kunnen opslaan.');
  } else {
    await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'declaratienummer')),'\''].join('')), ({ [`controlereden`]: reden }) );
    await Backendless.Messaging.sendEmailFromTemplate('Niet akkoord mail', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'declaratienummer')),[`reden`]: reden,[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/44c1800c611e457ccea3c1c3bf8fe1aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2898f6ab7da52d52d372f89653d6a27')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/a03bd34b22899b0547dee5694fe67071/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['controleredenselect'] = ___arguments.value;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/4be4c55422ba25ac0d2ba6135162794d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['controleredenomschrijving'] = ___arguments.value;
  ___arguments.context.pageData['controleredenselect'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/f554972ad0e449e6bf84cadd84a79ea5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/b57472495ac28b5ea4eeaefad27de37f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var reden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'declaratienummer')),'\''].join('')), ({ 'controlereden': null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/31d630dbde2a12a31ae96b0185964e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatum'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/45b5993d55aace9395ccc1425884debe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing')) == null) {
    date = null;
  } else {
    date = (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing'))));
  }

  return date

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/c4ccbd6a6f04b348a061239321f2c7da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e555df910e182bc184e77dab884c844f'), 'declaratienummer')),'\''].join('')), ({ 'controlereden': null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/a777b7dd0224a80992b1c5f757e293f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controlereden')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e555df910e182bc184e77dab884c844f')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/20fed8e8bf2983e8087dafada446d176/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ [`dateStyle`]: 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'controle')),'label': (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/327f9226ac9800551351356d1b17eebd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterstatus'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/311f9ec8ebef140a5b39aa58f29fa2e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/2eaab20ea8fc1386191c82882613e89e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','declaratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('Informatie aanvraag', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'declaratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`datum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'datumdeclaratie')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/85a23ced1bdfa10a09f14445f4792fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('vraagcontrolelorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'declaratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')),[`gemaaktdoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/1ed2c12a59f6055acd33c8fa28ccbdf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) != null ? true : ((getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')) != null ? true : false))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/4bfefdadaf0a0fc299272df7a2c36c45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/c3c1a408618c4698041a038b8bdc8f84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/34b8440f1771418f56fc397b6d9edeab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f178392d6c6346cfff015d5ff2bf7e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('453f9b73304601bb52a4f3711243ed17', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34b8440f1771418f56fc397b6d9edeab', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/9a242dc13bcd421edcba1837cd959aab/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'subsidie')) == 'DNN') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a242dc13bcd421edcba1837cd959aab'))['backgroundColor'] = '#e3e1e1';
  }

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('66f178392d6c6346cfff015d5ff2bf7e')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f178392d6c6346cfff015d5ff2bf7e', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f178392d6c6346cfff015d5ff2bf7e', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/9f828f3cf4924285a5feaafe871b7271/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/0c11b2dcee6dca1bc3f90927374e504d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtersubsidie'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrole/components/062ec963a3ecfe9adfd8ae2501de6e12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'','TE CONTROLEREN','\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join('')), ({ 'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtersubsidie')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn73mwn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['sorteer'] = 'aanmaakdatum';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['controleredenselect'] = null;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause('invoer=\'declaratie\'').setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakmaand')),'label': (getObjectProperty(item, 'aanmaakmaand')) });}))), ({ 'value': '%','label': 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND subsidie=\'','ZSD','\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('soort').setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'soort')),'label': (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/eeba4f11ff83adb518cd9bf27c2bfdd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND subsidie=\'','ZSD','\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/e2c61d87bc58b6e94c2169198c89c24a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/c844a5a1f7dc507f816a71317d32ffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/fd4dd1d1870d13bc8fdc99022b466aa2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'controleaantekeningen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')).length == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ 'aantekening': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumaantekening': (new Date()),'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/e5ec874e8ac1ea4302eda01272f18515/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\' AND datumdeclaratie LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/db3ca88257ea87823aaeddfbab489acd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/ea8e5f46728303469314cb096613459d/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/50dd46436e5f16324f9ae3ee4a7d1cc9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefuur'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/2da7cb39be92b6abfddf0885874b3b39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'urenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/7007895980926936a54d76ff730aa0d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'urenbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/b0a487118b0b294316a88d199f7392a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'urentotaal')) == 0) {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'urentotaal'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/1342996de18c646808b19b7414077874/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/bd170562f2ababa847212538578864a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/e3ef5e35146312ebcf9840bceeb7a932/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/49175a9f72a9bbab12feb41549060c06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmtotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/cde841b5de47cd08a98c3ed4749cd169/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragcalc')) == 0) {
    euro = '-';
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragcalc'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/f844ad9efa7ba454189e0434e6554814/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/3ce8ec9e449489fbef082b640b73e4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/d92a86f1e7649229796ac0de2abd89e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'uren')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'uren'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/268315d13ec1372eb592700dcdbb694a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/78464eddc63154cbc5b7bdf79277f436/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'aanmaakdatumaanpassing': (new Date()),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()),'maandakkoord': true }) );
      await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'aanmaakdatumaanpassing': (new Date()),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()),'maandakkoord': true }) );
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'NIET AKKOORD';
      await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'controle': 'NIET AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'controle': 'NIET AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'TE CONTROLEREN';
      await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'controle': 'TE CONTROLEREN','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'controle': 'TE CONTROLEREN','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
    await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'\''].join('')), ({ 'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'declaratienummer')),'info': 'declaratie komt van status OPNIEUW INGEDIEND','controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = ' #558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#e0ab0d';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/453f9b73304601bb52a4f3711243ed17/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f178392d6c6346cfff015d5ff2bf7e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('453f9b73304601bb52a4f3711243ed17', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34b8440f1771418f56fc397b6d9edeab', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/316a7eae0b1698e6b2a692072584ffee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var reden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null) {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving'));
  } else {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenselect'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null && (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving')) == null) {
    (function (message) { alert(message) })('Er moet een reden ingegeven worden om deze te kunnen opslaan.');
  } else {
    await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'declaratienummer')),'\''].join('')), ({ [`controlereden`]: reden }) );
    await Backendless.Messaging.sendEmailFromTemplate('Niet akkoord mail', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'declaratienummer')),[`reden`]: reden,[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/44c1800c611e457ccea3c1c3bf8fe1aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2898f6ab7da52d52d372f89653d6a27')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/a03bd34b22899b0547dee5694fe67071/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['controleredenselect'] = ___arguments.value;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/4be4c55422ba25ac0d2ba6135162794d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['controleredenomschrijving'] = ___arguments.value;
  ___arguments.context.pageData['controleredenselect'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/f554972ad0e449e6bf84cadd84a79ea5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/b57472495ac28b5ea4eeaefad27de37f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var reden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'declaratienummer')),'\''].join('')), ({ 'controlereden': null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/31d630dbde2a12a31ae96b0185964e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatum'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/45b5993d55aace9395ccc1425884debe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing')) == null) {
    date = null;
  } else {
    date = (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing'))));
  }

  return date

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/c4ccbd6a6f04b348a061239321f2c7da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e555df910e182bc184e77dab884c844f'), 'declaratienummer')),'\''].join('')), ({ 'controlereden': null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/a777b7dd0224a80992b1c5f757e293f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controlereden')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e555df910e182bc184e77dab884c844f')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/20fed8e8bf2983e8087dafada446d176/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'declaratie\' AND subsidie=\'','ZSD','\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'controle')),'label': (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/327f9226ac9800551351356d1b17eebd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterstatus'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/311f9ec8ebef140a5b39aa58f29fa2e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND subsidie=\'','ZSD',' \' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND subsidie=\'','ZSD','\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/2eaab20ea8fc1386191c82882613e89e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND subsidie=\'','ZSD','\' AND declaratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('Informatie aanvraag', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'declaratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`datum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'datumdeclaratie')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/85a23ced1bdfa10a09f14445f4792fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('vraagcontrolelorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'declaratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')),[`gemaaktdoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/1ed2c12a59f6055acd33c8fa28ccbdf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/4bfefdadaf0a0fc299272df7a2c36c45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/c3c1a408618c4698041a038b8bdc8f84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/34b8440f1771418f56fc397b6d9edeab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66f178392d6c6346cfff015d5ff2bf7e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('453f9b73304601bb52a4f3711243ed17', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('34b8440f1771418f56fc397b6d9edeab', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/9a242dc13bcd421edcba1837cd959aab/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'subsidie')) == 'DNN') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a242dc13bcd421edcba1837cd959aab'))['backgroundColor'] = '#e3e1e1';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/dnnmaandcontrolezsd/components/062ec963a3ecfe9adfd8ae2501de6e12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'','TE CONTROLEREN','\' AND subsidie LIKE\'','ZSD','\''].join('')), ({ 'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'declaratie\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND subsidie LIKE\'','ZSD','\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ae9330cf0d1e6e61dffad9e359f0f65', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('25386f857648dae49aa8aff65f0ec5af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f714bd326673d6b490215571b6edd459', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/a6ddb20388c34e97afd58d61b4165803/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = true;
  ___arguments.context.pageData['maandoverzichtakkoord'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2b8655d760b784883b545b5e2c60f9c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fbf54c86906befc4f439ed02193bd9b3', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['kostenplaats', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('kostenplaats').setGroupBy('kostenplaats').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2a3cbc427f488c8af2774fb1ca7eff3b', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'Werktijd\'',' AND controle=\'AKKOORD\' AND subsidie=\'DNN\''].join(''))).setProperties(['soort', 'Sum(uren) as uren', 'tariefuur', 'Sum(urenexbtw) as urenexbtw', 'Sum(urenbtw) as urenbtw', 'Sum(urentotaal) as urentotaal']).setSortBy('soort').setGroupBy('soort').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('380e44b5564a5dfbe9e5757f3eb98dac', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'Werktijd\'',' AND controle=\'AKKOORD\' AND subsidie=\'ZSD\''].join(''))).setProperties(['soort', 'Sum(uren) as uren', 'tariefuur', 'Sum(urenexbtw) as urenexbtw', 'Sum(urenbtw) as urenbtw', 'Sum(urentotaal) as urentotaal']).setSortBy('soort').setGroupBy('soort').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfc81f8d0c18cd3d7b0b509254658aea', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'Reiskosten / parkeerkosten\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cdcf3f53982659a3ff5795da2921a7c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'Reiskosten / parkeerkosten\'',' AND controle=\'AKKOORD\' AND bedraginput <> 0'].join(''))).setProperties(['soort', 'Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw', 'Sum(bedragcalctotaal) as bedragtotaal', 'count(soort) as aantal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('59ff2e4b354e4e82d6fe723633a6496c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'Vaste vacatiegelden\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw', 'Sum(bedragcalctotaal) as bedragtotaal', 'count(soort) as aantal', 'bedragcalc']).setSortBy('soort ASC').setGroupBy('bedragcalc').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c99c0f5f2a2ee0ac3fc31bd291aa7115', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'Voorgeschoten kleine uitgaven\' ',' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw', 'Sum(bedragcalctotaal) as bedragtotaal', 'count(soort) as aantal']).setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('18aab6f699e62a3a4348bd827907bb5c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'Thuiswerkregeling\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw', 'Sum(bedragcalctotaal) as bedragtotaal', 'count(soort) as aantal']).setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6778f775ccc26cfcfd9d8af8f91c5a28', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'Coördinatorenoverleg\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw', 'Sum(bedragcalctotaal) as bedragtotaal', 'count(soort) as aantal']).setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b671b666ea23d6388abf866da9a5265', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f92fe698a6874ac236e8d9706697404', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a37f9a2a8242171fe996800f00649137', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND urenbtw<>0'].join(''))).setProperties(['Sum(urenexbtw) as urenexbtw', 'Sum(urenbtw) as urenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND urenbtw=0'].join(''))).setProperties(['Sum(urenexbtw) as urenexbtw', 'Sum(urenbtw) as urenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw<>0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND kmbtw=0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragcalcbtw<>0'].join(''))).setProperties(['Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\'',' AND bedragcalcbtw=0'].join(''))).setProperties(['Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2b8655d760b784883b545b5e2c60f9c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('maandoverzichtakkoord').setGroupBy('maandoverzichtakkoord').setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f714bd326673d6b490215571b6edd459', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/b0495ea9577baec3b00e1bdb81c40087/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/4dde07442c35a5971c0998aab823946b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/edb51285268cb33640d5a04a94da665f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/59e66456051b2e07f5a8a6aaea5e262d/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  async onTitleAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Overzicht declaraties ingevoerd in de maand ',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),' - ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))].join(''))

  },
  /* handler:onTitleAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onColumnsAssignment */
  async onColumnsAssignment(___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('59e66456051b2e07f5a8a6aaea5e262d')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    A = 'Uren';
    B = 'Kilometers';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    A = 'Uren';
    A = 'Betreft';
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND controle=\'AKKOORD\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/cee870e278bab351e4e5e747df4804f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'urenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/cf1c1b3221568c0946c1d907028d066e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'urenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'urenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/e5f121045216195374a7825655bcdf27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/8d57763628b2680464b48b5f08d2c897/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'tariefuur'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/825eed757945b00fcf1397ec25ca037a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'tariefkm'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/442a8d859c447ed5ece2ad715a94104c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/ee6ffde4e713391cdd28da05ff492cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/b43128b24b58cfa98f6c86e90449fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b43128b24b58cfa98f6c86e90449fbfa', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/0083293170ed7a7905189a83ba718e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'maandoverzichtakkoord'))];
  for (var j_index in list) {
    j = list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'maandoverzichtakkoord')) == 1) {
      ___arguments.context.pageData['maandoverzichtakkoord'] = 1;
    }
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandoverzichtakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/759ff4ee989244a40dd78fe5ff77b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/8d182e157fa1e64dca945f6317ca70a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/deee0a06623c9e44e6e9ebe96dc916ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deee0a06623c9e44e6e9ebe96dc916ce', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/0d3e958c47d525ca4ee375b67884f1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/167e783ed44c844f7d93d60d07e3ace2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandselectie')) == null) {
    (function (message) { alert(message) })('U dient eerst de maand te selecteren voordat u een factuur kunt opmaken.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = true;
    ___arguments.context.pageData['INVOICE'] = false;
    ___arguments.context.pageData['VIEW'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f714bd326673d6b490215571b6edd459', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', true);
    await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );
    ___arguments.context.pageData['factuurnummer'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/359deb7271c7ebc941874474de24a14c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/25386f857648dae49aa8aff65f0ec5af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == true) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('25386f857648dae49aa8aff65f0ec5af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/58cd94c8d92e575ac13d5bc664ffa391/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/e61405f3e5e9e8d92f3a4a53b289d06d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/d05dde1c23aae976ac4d1711c99db218/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/8f465d5f56d41fd77d3bba4ad0fe1cd1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/b042965597ab58d182efe49443d2bd4c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/c46c49345d390b33f8f9fe4c18d43641/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/48abbe635c4cf09158ea9065bc590d1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/06657ca945c2ad438fa409dbc9faed18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/574a0f155f748c53e9a5d71345bdf882/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/001baa1ff71bca787fcdf7f87e51e458/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/8af521110fc5173b5566a99943f30197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/ca654e33a74a3908db4f71d17b9ba957/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/9695d8b181662d02ba845776ecb88571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/d31cb031efe92bcef27dd30c166debe9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/7acd8669688de30b25f548a20e3934aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/2da62ab21281ef0706b209e5fa7ef6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2da62ab21281ef0706b209e5fa7ef6b5', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/9a07a37569c9d2f84437f1ab9add098d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/86e2eaaf2781f02ae9f8344f58a9ffe3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/c415e9bfc50ea9780785b50471299bd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8af521110fc5173b5566a99943f30197')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurnummer')) == null) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('48abbe635c4cf09158ea9065bc590d1f')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06657ca945c2ad438fa409dbc9faed18')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'ibantennamevan')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['maxHeight'] = '700px';
    ___arguments.context.pageData['FACTGEGEVENS'] = false;
    ___arguments.context.pageData['INVOICE'] = true;
    ___arguments.context.pageData['VIEW'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f714bd326673d6b490215571b6edd459', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/29b1b26478246886942dcd297b5ff4f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/4fd709b151d62e041a7c3481ece40e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f714bd326673d6b490215571b6edd459', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/e61c2ef961933bdcbb89393d96a6b1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('Deze pagina kan enkel geprint worden als het maandoverzicht akkoord is bevonden.');
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/38288ef8776bacfe3338d7249f0c36ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/2a3cbc427f488c8af2774fb1ca7eff3b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/bfc81f8d0c18cd3d7b0b509254658aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/4b671b666ea23d6388abf866da9a5265/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/834cfcd4e27b987ed4466cb27c593dc3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/9f06ba9552a302e9bfa60d92b9caf9ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer')),'.'].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),'.'].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/f34d569b704ca3f582d57dc761d77c13/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f34d569b704ca3f582d57dc761d77c13', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/764f12c6d24758fcacf5c408b91ad844/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('509b9852384c56e74cb8c39112130ccf'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('509b9852384c56e74cb8c39112130ccf'), 'bedragbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/ff55a76e46813fe9a68857a660d3dcbc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('509b9852384c56e74cb8c39112130ccf'), 'bedragexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/9c8b0b4e51116ce2f46c01ae2a7aee36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/e195e98ec5550d29d8e9b78feccbe4b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/4e8f4ab9b515635b26c4f59772b6a47b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/59ff2e4b354e4e82d6fe723633a6496c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/2cdcf3f53982659a3ff5795da2921a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/287287e80ea50567800225954bc9846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3aad1d9b05d8dbb6a044dc8b5f3495d6'), 'totaalbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/42464328b06c3752cea38d2163767e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a35d3424c933ab3c272c926c25ccf46a'), 'totaalbedrag'));
  await format();
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/cd9c573c7d9b4fde829786d51d4d3e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'urenexbtw'));
  ___arguments.context.pageData['inclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'urenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/d91f7ff4b2d96b7c4e18762a1dca46b4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'urenexbtw'));
  ___arguments.context.pageData['exclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'urenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/64561efe908764ae5c6f20d4abe96868/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['inclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/364e6219fc5ff9c198e6aa8c015b7dda/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['exclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/058d76a9a81f00638655cf8b0da9d2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/4ab23618a7a8c3494357e6cf5b9220a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['exclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/7b8465ac5d722799e22bfac594b51c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/a5390634b17a414c9ded4a72641c81f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/bcfa0f2770a9b082f7d3e74b107c3afe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'exclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/2841456ab0ca8b1de649b233ac5e51f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.pageData, 'inclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/34be58fed185e7f99a080af5778ac4b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/e39b8939739fadff893413ca228af41d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/1668b0453df80c8ce9dfe71be69fb853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/2f92fe698a6874ac236e8d9706697404/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/a37f9a2a8242171fe996800f00649137/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/5e7d19b2f1a52b3477ff91dda6db4de5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/539f2d64ba0bafcb899fea4823751527/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'urentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'urentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/509b9852384c56e74cb8c39112130ccf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/651ef5a1ff7afef951671c02d2134b1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/84430d2edca3a70f79d201126ff94375/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/9abccdb7d87b42cbc4bb37cfb854ad51/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/3ddf7cac281621eeec87c315dbb28265/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/735616997b3586fd6d644757da252a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735616997b3586fd6d644757da252a2d', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/2de8faf70c0b33d79bddd4f629f69bfc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e034686def628f7648db17434586c506'), 'regel3nc'));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e034686def628f7648db17434586c506'), 'regel3bl'));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn28ewl') {
      content2 = 'Kostenplaats 7012: reiskosten/ parkeerkosten';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn12sst') {
      content2 = 'Kostenplaats 7022: reiskosten/ parkeerkosten';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn13tbt') {
      content2 = 'Kostenplaats 7022: reiskosten/ parkeerkosten';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn02lws') {
      content2 = 'Kostenplaats 7012: reiskosten/ parkeerkosten';
    }
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/b47731d1e605fb51fdf28405747a1ffb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['factuurnummer'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/da13a7cc0b869777bfb44679bbe6e56e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e034686def628f7648db17434586c506'), 'regel3bl1'));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn28ewl') {
      content2 = 'Kostenplaats 7013: voorgeschoten kleine uitgaven';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn12sst') {
      content2 = 'Kostenplaats 7023: voorgeschoten kleine uitgaven';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn13tbt') {
      content2 = 'Kostenplaats 7023: voorgeschoten kleine uitgaven';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn02lws') {
      content2 = 'Kostenplaats 7013: voorgeschoten kleine uitgaven';
    }
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/599b909b0142fe61127df516ca5aa6dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1w4uPc6DhTc1Xp5XBDOHJlGRSfja-cIx1/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/f0cceb6c58835d345a4378b2302ca277/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    text = 'Netwerkcoördinator';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    text = 'Bestuurslid';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    text = 'Personeelslid';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'ZSD') {
    text = 'Projectlid';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/31cc03d5c6b8275179ab60e89b9a6258/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d8538d1d693b8c06dcbdb513910cd4c8'), 'regel3nc'));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d8538d1d693b8c06dcbdb513910cd4c8'), 'regel3bl'));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn28ewl') {
      content2 = 'Kostenplaats 7012: reiskosten/ parkeerkosten';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn12sst') {
      content2 = 'Kostenplaats 7022: reiskosten/ parkeerkosten';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn13tbt') {
      content2 = 'Kostenplaats 7022: reiskosten/ parkeerkosten';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn02lws') {
      content2 = 'Kostenplaats 7012: reiskosten/ parkeerkosten';
    }
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/c0e8c8e585efaa285c0854027df80213/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d8538d1d693b8c06dcbdb513910cd4c8'), 'regel3bl1'));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn28ewl') {
      content2 = 'Kostenplaats 7013: voorgeschoten kleine uitgaven';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn12sst') {
      content2 = 'Kostenplaats 7023: voorgeschoten kleine uitgaven';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn13tbt') {
      content2 = 'Kostenplaats 7023: voorgeschoten kleine uitgaven';
    } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'Dnn02lws') {
      content2 = 'Kostenplaats 7013: voorgeschoten kleine uitgaven';
    }
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/ea17454e6f75312b7d086f7685330a4f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d8538d1d693b8c06dcbdb513910cd4c8'), 'regel3bl2'));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/bd7a823a0a6bbb5c7ba868e75672ea99/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    content2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e034686def628f7648db17434586c506'), 'regel3bl2'));
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    visible = false;
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    visible = false;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/bad1987b2381573e85b317378631dc9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/42dfdacf0d7c0b256578d2577ee16774/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('42dfdacf0d7c0b256578d2577ee16774', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/9dd4e9d3bc5e91efda29f6ad206e0f65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/01d1cede7ddfd86982b1135b0414bda9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('72b450fb65a6cc1b362f02b38426c8e1'), 'totaalbedrag'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/0557151bd971d15732de6d66926fee7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/fbf54c86906befc4f439ed02193bd9b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/36075d55d7d778a4af9c033b8f3a3e8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'urentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'urentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/380e44b5564a5dfbe9e5757f3eb98dac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/6748844c0a0e7f2221a4d85e16fd381c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('36075d55d7d778a4af9c033b8f3a3e8b'), 'tariefuur'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/bdeab7c33257472a8865b28a20c82728/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('36075d55d7d778a4af9c033b8f3a3e8b'), 'urenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('36075d55d7d778a4af9c033b8f3a3e8b'), 'urenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/2fa94cbbbf624c0e539326b1cc58c3af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('36075d55d7d778a4af9c033b8f3a3e8b'), 'urenexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/18aab6f699e62a3a4348bd827907bb5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/f6a8e15d964e0216acdc2e9270b69f44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/79ef7c73bcdb27f4ee7e5906d6d944e1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6a8e15d964e0216acdc2e9270b69f44'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6a8e15d964e0216acdc2e9270b69f44'), 'bedragbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/e115bd644453d74f4c2e4a8b2cb7b689/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6a8e15d964e0216acdc2e9270b69f44'), 'bedragexbtw'));
  await format();
  ___arguments.context.pageData['twreuro'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/031bd2e6c2bc9a6d594671be6de64a59/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f6a8e15d964e0216acdc2e9270b69f44'), 'bedragexbtw')) / 21500)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/a843d8dfce1298d196cacbf28ba5092e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandoverzichtakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden om te factureren';
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1517149db10ed683c15f524558e9cfa6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f29ec797d8daefe498a8047ad21afa7d', false);
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1517149db10ed683c15f524558e9cfa6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f29ec797d8daefe498a8047ad21afa7d', true);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/c99c0f5f2a2ee0ac3fc31bd291aa7115/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/c1ed7f844e213b31557f8f65c7bfc3d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4ec332ebd088ff98c53db7abbca6c14'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4ec332ebd088ff98c53db7abbca6c14'), 'bedragbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/f8659da22431e98ccfee7eb457df6e5c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e4ec332ebd088ff98c53db7abbca6c14'), 'bedragexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/e4ec332ebd088ff98c53db7abbca6c14/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/4c119b8aa0e3fb267f0eafc827c6922e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('509b9852384c56e74cb8c39112130ccf'), 'bedragcalc'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/6778f775ccc26cfcfd9d8af8f91c5a28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/50d1601871f82e068d7a23e8748322bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/38382c786e48a9d5b38fa028a9883668/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('50d1601871f82e068d7a23e8748322bd'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('50d1601871f82e068d7a23e8748322bd'), 'bedragbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmaandoverzicht/components/589911e20db8028dc72843f366088161/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), getValueLength(euro));
    rest = rest.slice(1, rest.length);
    if (getValueLength(rest) == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = getValueLength(part);
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, getValueLength(part) - dotnumber),'.',part.slice((((getValueLength(part) - dotnumber) + 1) - 1), getValueLength(part))].join('');
      length2 = getValueLength(part);
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('50d1601871f82e068d7a23e8748322bd'), 'bedragexbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmailsversturen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriodnnbhrlieke' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) == 'loriodnnbhrjm')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnnmailsversturen/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmailsversturen/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmailsversturen/components/523bad1d1835ef643dfc92e26e1d9ebd/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause('userStatus = \'ENABLED\'').setProperties('username').setSortBy('username DESC').setGroupBy('username').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'username')),'label': (getObjectProperty(item, 'username')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('831483018a35486d60e4f438182787f6', (await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmailsversturen/components/11ac106c4cef1f32c248f8186f3e0005/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'NC') {
    await Backendless.Messaging.sendEmailFromTemplate('newusernetwerkcoordinator', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'BL') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserbestuurslid', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'PL') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserpersoneelslid', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'ZSD') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserzsd', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
  }
  (function (message) { alert(message) })('De email is verzonden');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmailsversturen/components/d6d21e72cdd9f229610d2a3c5f6487eb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var list;


  list = ((await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['userStatus = \'ENABLED\' AND rol=\'ZSD\' OR ','userStatus = \'ENABLED\' AND rol=\'PL\' OR ','userStatus = \'ENABLED\' AND rol=\'NC\' OR ','userStatus = \'ENABLED\' AND rol=\'BL\''].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bcc'] = (list.join(','));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmailsversturen/components/2b246e258a6f2faa06338f175a867fd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['disablesave'] = true;
  await Backendless.Messaging.sendEmailFromTemplate('algemenemail', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: [(getObjectProperty(___arguments.context.pageData, 'bcc')), 'backendless@lorio.nl'], query: '', uniqueEmails: true }), undefined, undefined);
  (function (message) { alert(message) })('De algemene mail is verzonden');
  ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/b63dd5617c0b802d3b6bdfffa8171afa/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/24c59afc9b7869a85ebbcb3dbd4e1823/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == null) {
    await Backendless.Data.of('declaraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ [`change`]: true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND declaratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == false) {
    await Backendless.Data.of('declaraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ [`change`]: true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND declaratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true) {
    await Backendless.Data.of('declaraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ [`change`]: false }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND declaratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) != 'AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/8fba7ccc73ad762eb6036605780f2255/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Alleen werktijd' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd' ? false : true)))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'uren')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'uren'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/0af2e266604f9143f7cae657d88abcdc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/cdc6c82bd72ed8df431d68254ec75002/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Voorgeschoten kleine uitgaven' ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalc')) == 0) {
    euro = '-';
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalc'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/0a9a0e7fc609f0536cd4851d2431f799/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Alleen werktijd' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd' ? true : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('declaraties').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/8d349db77ecb28f4320418027913049c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? true : false) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('declaraties').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/e1584521a9f12d5e7fa6bcceefb3de9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Voorgeschoten kleine uitgaven' ? true : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('declaraties').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/5cc10345685b54b6e559aa9e945fa2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/3466f6d2e332d4470ba847ba5d5bcb4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d032df632a81c08ddb540411b2af486a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/b17a9c5be42f40f4f4c4a2d438825853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'fileref': (getObjectProperty(___arguments.context.pageData, 'file')),'file': (getObjectProperty(___arguments.context.pageData, 'file')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));
  if ((getObjectProperty(___arguments.context.pageData, 'oldfileref')) != null) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'oldfileref'))));
  }
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('b17a9c5be42f40f4f4c4a2d438825853');

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['oldfileref'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'));

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('b17a9c5be42f40f4f4c4a2d438825853');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/5736d87b0cd63d924988b453b0dd4c35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('declaraties').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'objectId')),'\''].join('')) );
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref')) == null) {
  } else {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref'))));
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''))).setSortBy('declaratienummer DESC').setPageSize(10))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;await ( async function (message){ alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['sorteer'] = 'datum';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filtermaand'] = '%';
  ___arguments.context.pageData['filterstatus'] = '%';
  await Backendless.Data.of('declaraties').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ [`change`]: false }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/f992a0fc4606d7ce4a22b8a29a4866db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag')) == 0) {
    euro = null;
  } else {
    euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag'));
    await format();
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/6658af14ef125f3b1da798ee92c85184/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('declaraties').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/fbcb0639f0a88b6106985c5ea3916098/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/b8abb0b929925621d74834d7f84ba81e/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = '#558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = '#e0ab0d';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/61fb7db6d2c2cabad2d63507fe829a43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'maandakkoord')) == true) {
    await Backendless.Data.of('declaraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'objectId')),'\''].join('')), ({ 'change': false,'aanmaakdatumaanpassing': (new Date()),'controle': 'OPNIEUW INGEDIEND','maandakkoord': false }) );
    await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'declaratienummer')),'aanmaakdatumaanpassing': (new Date()),'controle': 'OPNIEUW INGEDIEND','maandakkoord': false,'activiteitdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));
    (function (message) { alert(message) })('De declaratie is opnieuw ingediend');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d10e4d172897ca2c4a1202a11bf8e7a5', false);
  } else {
    await Backendless.Data.of('declaraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'objectId')),'\''].join('')), ({ 'change': false,'controle': 'OPNIEUW INGEDIEND' }) );
    await Backendless.Data.of('historiestatus').save( ({ 'declaratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'declaratienummer')),'aanmaakdatumaanpassing': (new Date()),'controle': 'OPNIEUW INGEDIEND','maandakkoord': false,'activiteitdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));
    (function (message) { alert(message) })('De declaratie is opnieuw ingediend');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d10e4d172897ca2c4a1202a11bf8e7a5', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/d10e4d172897ca2c4a1202a11bf8e7a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'change')) == true && (getObjectProperty(___arguments.context.dataModel, 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/938d30edda12673e1914c67b903b01f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND declaratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/072cdd11d74fc821eaaec9eeea9e4c0f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['filtermaand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['declaratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\'','AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/6a3b7b69cd95019f9bd477f7a8f8e834/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'controle')),'label': (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/f6e4eabb330a00e398e11533c36211b2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'%\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND ','controle LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'%\''].join(''))).setProperties('aanmaakmaand').setSortBy('aanmaakmaand ASC').setGroupBy('aanmaakmaand').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakmaand')),'label': (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/e0cec201524fc0b9ce5edc2378694b59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterstatus'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'%\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/00b628d698e515548e1c9525c73db767/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/18953fe3a81a74c78e69969f4071bd05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/3001d1e1a958124ba0de2cd220f4d377/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/28c1e187a48a63d75ba160d481b41918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref')) == null) {
  } else {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'))));
  }
  await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'declaratienummer')),'\''].join('')), ({ 'file': null,'fileref': null }) );
  (function (message) { alert(message) })('De bijlage is verwijderd.');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/d229ab1a613e24df18a57658f639f02b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/07c881861aa51d835abd61c7d8a92dbe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/6687a75c724c5d3d5a6b9a1c0be8a2ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'betreft')) == null) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'betreft'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/6321c07404d13b614177632cd072e641/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/1d51a1929bd35fba10c43c7896ab5d5d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'subsidie')) == 'DNN') {
    text = 'Professionalisering';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'subsidie')) == 'ZSD') {
    text = 'ZSD';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/20cd6d3a82db165936823f1b0006e05b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijndeclaraties/components/4111a0a5943a3fe4d2bdcf8ca287c0fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijngegevens/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('bestuurslid')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabestuurslid', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijngegevens/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('bestuurslid')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabestuurslid', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijngegevens/components/cbe40e7fe223de879fdcc794e22ef1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;(function (componentUid, listItems){ ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cbe40e7fe223de879fdcc794e22ef1b2', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmijngegevens/components/24448b06c05c53a4a4c7f366d736403e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail. ');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('useraanpassingen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`emailupdate`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emailupdate'] = ('De email is verzonden'.toUpperCase());
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnmijngegevens/components/b7cd3465433ff6d941452d0458e2f0c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'btwplichtig')) == 1 ? 'Ja' : 'Nee')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmijngegevens/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnnmijngegevens/components/b92e094af901585b56f3f9fd132ba2d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijngegevens/components/7b8304e6917e23cb12d74c36de2937ea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijngegevens/components/654e855d5b290cae5527bc2f4f6bde5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    text = 'Netwerkcoördinator';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
    text = 'Bestuurslid';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    text = 'Personeelslid';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'ZSD') {
    text = 'Projectlid';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnmijngegevens/components/57eb1fc20f61cc7f8d5fc9fe37b56a94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijngegevens/components/ad76d327dd3d182c19f36f96773b0ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad76d327dd3d182c19f36f96773b0ab3', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnmijngegevens/components/5b2a824695749c17cb4da796cdfcecf5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijngegevens/components/f5596b12de2bd03f1ed94a43ef1138dd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijngegevens/components/2adafcd487e2cf4a306d6bb893179bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijngegevens/components/b9e397841257984168dc6c1a7ab76233/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijngegevens/components/7d73f29d80a26b6bd2111ed7fc691dec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijngegevens/components/063ece8f772e6a616a93505b32876d41/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijngegevens/components/e742c20af8e7be2c949fc7cce63de0f3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijngegevens/components/cb3361e47f5d58d4a0393f6576ddf21e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijngegevens/components/41f16b1452a54d78b0af28fa346e0a94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijngegevens/components/9e8b61cef3f8c07db3a96d2191def80a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnmijngegevens/components/559f1d3b394db28f7bbeea2dcb3d36ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://dnn23.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('559f1d3b394db28f7bbeea2dcb3d36ce');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('559f1d3b394db28f7bbeea2dcb3d36ce');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/dnnmijngegevens/components/20c3c9c216c24da6ed187defb2748946/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dnnmijngegevens/components/9d5e92a96cb93068a3d8adb8ebf42a47/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijngegevens/components/0615cc02759c0e385f887b013f75e7d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dnnmijngegevens/components/775c7a8524f6b7aa3e0a745113347624/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dnnprojectkosten/components/c61e972ea44d60bf24f273727da2add6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('soortprojectkosten').find(Backendless.DataQueryBuilder.create().setSortBy('soort').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'soort')),'label': (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnprojectkosten/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2c935f216085692a30788fa699be4e1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datum')) == null) {
    (function (message) { alert(message) })('Datum activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c61e972ea44d60bf24f273727da2add6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'soort')) == null) {
    (function (message) { alert(message) })('Soort projectkosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('646c72c5b7de6d7edd5b6d39fc94eb67')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'kostenplaats')) == null) {
    (function (message) { alert(message) })('Kostenplaats dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('52048d8528aa762cc2b47b9c6f557476')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null) {
    (function (message) { alert(message) })('Bedrag excl. btw dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('341dd443b2c419f32d7bbddc56d88001')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    (function (message) { alert(message) })('BTW dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('declaraties').save( ({ 'aanmaakdatum': (new Date()),'datum': (getObjectProperty(___arguments.context.pageData, 'datum')),'soort': (getObjectProperty(___arguments.context.pageData, 'soort')),'omschrijving': (getObjectProperty(___arguments.context.pageData, 'omschrijving')),'kostenplaats': (getObjectProperty(___arguments.context.pageData, 'kostenplaats')),'bedraginput': (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')),'btw': (getObjectProperty(___arguments.context.pageData, 'btw')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'organisatie': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'netwerknaam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'netwerknaamnaam')),'tariefkm': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tariefkm')),'tariefuur': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tariefuur')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'file': (getObjectProperty(___arguments.context.pageData, 'file')),'fileref': (getObjectProperty(___arguments.context.pageData, 'file')),'controle': 'PROJECTKOSTEN','rol': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),'invoer': 'projectkosten' }) ));
    ___arguments.context.pageData['datum'] = null;
    ___arguments.context.pageData['soort'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    ___arguments.context.pageData['kostenplaats'] = null;
    ___arguments.context.pageData['bedragexbtw'] = null;
    ___arguments.context.pageData['btw'] = null;
    ___arguments.context.pageData['disablesave'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3342df5cf51474ded7e42463ff683bb6');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/dnnprojectkosten/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/3342df5cf51474ded7e42463ff683bb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  ___arguments.context.pageData['file'] = (['https://dnn23.lorio.nl/api/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
      ___arguments.context.pageData['disablesave'] = true;

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadSuccess */
  onUploadSuccess(___arguments) {
      ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/dnnprojectkosten/components/b63dd5617c0b802d3b6bdfffa8171afa/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/dnnprojectkosten/components/8fba7ccc73ad762eb6036605780f2255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var value, part, euro, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalcbtw'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnprojectkosten/components/0af2e266604f9143f7cae657d88abcdc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var value, part, euro, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalctotaal'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnprojectkosten/components/5cc10345685b54b6e559aa9e945fa2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  ___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a')['change'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/5736d87b0cd63d924988b453b0dd4c35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('declaraties').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'objectId')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify('invoer=\'projectkosten\''),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/d6ab1a010ef99e6a2728f9ec9fd2249c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
      await Backendless.Data.of('declaraties').bulkUpdate( 'invoer=\'projectkosten\'', ({ 'change': false }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dnnprojectkosten/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;await ( async function (message){ alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('beheerder'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['jaar'] = '%';
  ___arguments.context.pageData['maand'] = '%';
  ___arguments.context.pageData['soortselect'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify('invoer=\'projectkosten\''),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dnnprojectkosten/components/f9359156faa97e7212ed45a7ccf19bcf/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async onValueAssignment(___arguments) {
    var cent, dotnumber, euro, length2, part, rest;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€',part,',',rest,'0'].join('');
    } else {
      euro = ['€',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€',part,',','00'].join('');
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null && (getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    euro = '0';
    await format();
  } else if ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null) {
    euro = '0';
    await format();
  } else if ((getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    euro = '0';
    await format();
  } else {
    euro = ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btw')) + (getObjectProperty(___arguments.context.pageData, 'bedragexbtw'));
    await format();
  }

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/dnnprojectkosten/components/1f27ee7f3fbe777dd2310cb662635797/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d6f72641f6616cf6d364aebb41dfa268')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d6f72641f6616cf6d364aebb41dfa268', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51365b1da4fcbc9bb4c46aac40934e1c', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d6f72641f6616cf6d364aebb41dfa268', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51365b1da4fcbc9bb4c46aac40934e1c', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/e7ca9196eda7093b486544575e6a92ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('soortprojectkosten').save( ({ 'soort': (getObjectProperty(___arguments.context.pageData, 'toevoegensoort2')) }) );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('c61e972ea44d60bf24f273727da2add6', (await Promise.all((await Backendless.Data.of('soortprojectkosten').find(Backendless.DataQueryBuilder.create().setSortBy('soort').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'soort')),'label': (getObjectProperty(item, 'soort')) });}))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d6f72641f6616cf6d364aebb41dfa268', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51365b1da4fcbc9bb4c46aac40934e1c', false);
  ___arguments.context.pageData['toevoegensoort2'] = '';
  (function (message) { alert(message) })('De nieuwe soort is succesvol toegevoegd aan de lijst');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/bc8266bbe60fa1b653547263603554a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function format() {
  euro = euro / 10000;
  cent = Math.round(100 * euro);
  euro = cent / 100;
  euro = String(euro);
  if (euro.indexOf('.') !== -1) {
    part = euro.slice(0, (euro.indexOf('.') + 1) - 1);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    rest = euro.slice(((euro.indexOf('.') + 1) - 1), euro.length);
    rest = rest.slice(1, rest.length);
    if (rest.length == 1) {
      euro = ['€ ',part,',',rest,'0'].join('');
    } else {
      euro = ['€ ',part,',',rest].join('');
    }
  } else {
    part = euro.slice(0, euro.length);
    length2 = part.length;
    dotnumber = 3;
    while (length2 > dotnumber) {
      part = [part.slice(0, part.length - dotnumber),'.',part.slice((((part.length - dotnumber) + 1) - 1), part.length)].join('');
      length2 = part.length;
      dotnumber = dotnumber + 4;
    }
    euro = ['€ ',part,',','00'].join('');
  }
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalc'));
  await format();

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dnnprojectkosten/components/10afb4add8552c53037fb16b87ab42f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d032df632a81c08ddb540411b2af486a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/953aca84f40365f4a391a53186fd300f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'projectkosten\'',' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))).setProperties('aanmaakjaar').setSortBy('aanmaakjaar ASC').setGroupBy('aanmaakjaar').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakjaar')),'label': (getObjectProperty(item, 'aanmaakjaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnprojectkosten/components/ad35718c4f84ac0a5bc7e9f98a4ffd98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaar'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/a2ebd64b89fb09fb4a2214a8a98c6e29/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))).setProperties('aanmaakmaandnum').setSortBy('aanmaakmaandnum ASC').setGroupBy('aanmaakmaandnum').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakmaandnum')),'label': (getObjectProperty(item, 'aanmaakmaandnum')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnprojectkosten/components/b5bc09a3fe96b5f8581fed9143aded36/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/4dcd3141d7e99d938cb9e436d5bbd7be/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('declaraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\''].join(''))).setProperties('soort').setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'soort')),'label': (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/dnnprojectkosten/components/bd416a242bcc7b222fc4a4961b5668e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['soortselect'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/268944f95998b2ef8d0bb78f6043aa1e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('475f63d88e3bd245e8ab5c96db2f6b41')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('475f63d88e3bd245e8ab5c96db2f6b41', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('475f63d88e3bd245e8ab5c96db2f6b41', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/64c39e1f918fa144ed9efc62d647ebee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('475f63d88e3bd245e8ab5c96db2f6b41')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('475f63d88e3bd245e8ab5c96db2f6b41', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('475f63d88e3bd245e8ab5c96db2f6b41', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/23ec68e36589725d8601ac835f15e1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dnnprojectkosten/components/f2842bec7127ac5755ec311e435e65c9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['oldfileref'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'));

  },
  /* handler:onBeforeUpload */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  ___arguments.context.pageData['file'] = (['https://rapidwork.backendless.app/api/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async onUploadSuccess(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('declaraties').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'fileref': (getObjectProperty(___arguments.context.pageData, 'file')),'file': (getObjectProperty(___arguments.context.pageData, 'file')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));
  if ((getObjectProperty(___arguments.context.pageData, 'oldfileref')) != null) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'oldfileref'))));
  }
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f2842bec7127ac5755ec311e435e65c9');

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/dnnprojectkosten/components/8955ad5e80c16dde2126fe26e1022c9f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('declaraties').bulkUpdate( (['declaratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'declaratienummer')),'\''].join('')), ({ 'file': null,'fileref': null }) );
  (function (message) { alert(message) })('De bijlage is verwijderd.');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('declaratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/db5546014b7940ad8771a98d85f83036/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, transactionId, totpQR_Path, enableResult, secret;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function enable2FA() {
  enableResult = (await Backendless.Request.put(`${Backendless.appPath}/services/TOTP/enable2fa`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  totpQR_Path = (getObjectProperty(enableResult, 'totpQR_Path'));
  secret = (getObjectProperty(enableResult, 'secret'));
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}


  try {
    await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  );
    ___arguments.context.pageData['transactionId'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId'));
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'totpAuthEnabled')) == false) {
      await enable2FA();
      ___arguments.context.pageData['qrURL'] = ([(Backendless.appPath),'/files/',totpQR_Path].join(''));
      transactionId = (getObjectProperty((await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  )), 'transactionId'));
      ___arguments.context.pageData['transactionId'] = transactionId;
    }

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 3033) {
    } else if ((getObjectProperty(error, 'code')) == 3003) {
      await setError((new Error('Gebruikersnaam en/of wachtwoord niet correct')));
    } else if ((getObjectProperty(error, 'code')) == 3036) {
      await setError((new Error('Uw account is geblokkeerd vanwege te veel mislukte aanmeldingen. Uw account zal na 24 uur weer toegankelijk zijn. Indien u eerder weer toegang wilt hebben neem dan contact op met info@lorio.nl')));
    } else {
      await setError(error);
    }

  } finally {
    if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId')).length) {
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a12c454e2886534edcf4393894d22219', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a69240f4cce6798bf5d2c918c74c2f4', true);
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ce3e81b02364eaa3c0c11e2f895e801')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/7dfd192d040ea3656b0b8c42084ff3eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')) == null) {
    (function (message) { alert(message) })('Vul je gebruikersnaam in om het wachtwoord te resetten.');
  } else {
    (function (message) { alert(message) })('Als de opgegeven gebruikersnaam bekend is, is er een e-mail verstuurd met een link om het wachtwoord te resetten.');
    await Backendless.Request.post(`${Backendless.appPath}/services/restorepassword/restorepassword`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username'))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/9b250b5ac5ef73d362b40c5ef967bc42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPasswordVisible'] = (!(getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4edd272bd7fb7f6f22eae3525232662'))['type'] = ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) ? 'input' : 'password');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b250b5ac5ef73d362b40c5ef967bc42'))['color'] = '#89b087';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b250b5ac5ef73d362b40c5ef967bc42'))['color'] = '#545C5C';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['isPasswordVisible'] = false;
  ___arguments.context.pageData['qrURL'] = null;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('927c9caef221532a3a695d8ca4ded5cb')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inlogpagina/components/8abb41ce996c4b251fb9cfd598ae3f9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error2'] = error;
}


  try {
    await (async function(user, stayLoggedIn) {
    	Backendless.Users.setCurrentUser(user, stayLoggedIn)
    })((await Backendless.Request.post(`${Backendless.appPath}/services/TOTP/auth`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'transactionId': (getObjectProperty(___arguments.context.pageData, 'transactionId')),'code': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'mfawachtwoord')) })), false);

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 0) {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    } else {
      await setError(error);
    }

  } finally {
    if (await Backendless.UserService.isValidLogin()) {
      if ((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('bestuurslid')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabestuurslid', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);
      }
    } else {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/0ea61c9bfc8fb45df3185d0f605189d1/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'qrURL'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/00c12203fb5fb62c8d517401c5968862/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/16d92db457dc864621a94ee99e14c566/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1YuQnwjOv1qir1xSjqoebTwklFBI0XL_d/view?usp=drive_link', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/0173bdb7cbfb9807c03bcdb681aba722/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/b54da5fce80eb9799071e36900094755/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/PrivacyverklaringLoriov1.5.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/f2f1ddbbaf1ba8f3f14a3e6fd4285a52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/Gebruikersvoorwaarden DNN v1.0.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/notallowed/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/notallowed/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('netwerkcoordinator')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginanetwerkcoordinator', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));
  await Backendless.Data.of('newuserrequests').bulkUpdate( 'objectId is not null', ({ [`aanmaken`]: false }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/permissions/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnhoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/67f403196da705f23d86dfac2267d69b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dnnmailsversturen', undefined);
  if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('Selecteer naam');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Selecteer email');
  } else if ((getObjectProperty(___arguments.context.pageData, 'usernameregister')) == null) {
    (function (message) { alert(message) })('Vul username in');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('newuser', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`verzender`]: 'Lorio' }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'NC') {
    await Backendless.Messaging.sendEmailFromTemplate('newusernetwerkcoordinator', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'BL') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserbestuurslid', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'PL') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserpersoneelslid', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'ZSD') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserzsd', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
  }
  await Backendless.Messaging.sendEmailFromTemplate('newuseraangemaakt', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'aangemelddooremail')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`aangemelddoor`]: (getObjectProperty(___arguments.context.pageData, 'aangemelddoor')) }), undefined);
  (function (message) { alert(message) })('De inloggegevens zijn verzonden naar de nieuwe user en de aanvrager heeft bevestiging ontvangen via mail.');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/3c46bf080591e52937d1171cdf247b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, j, declaratieslist, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesmnl() {
  beheerders = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('rol=\'beheerder\'') }).send());
  beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('objectId is not null') }).send());
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(j, 'username')),'\''].join(''))) }).send());
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      for (var l_index in beheerderslist) {
        l = beheerderslist[l_index];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions declaraties uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties uitgevoerd');
}


  await permissionsdeclaratiesmnl();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/d35d2ecc5053f5d217e97dd6aa67a7fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, m, gebruikersbeheerlist, item, gebruikersbeheer, userslist2, users2, j, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  await Backendless.Data.of('gebruikersbeheer').bulkDelete( 'objectId is not null' );
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users') }).send());
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`dashboardnaam`]: (getObjectProperty(j, 'dashboardnaam')),[`naam`]: (getObjectProperty(j, 'naam')),[`organisatie`]: (getObjectProperty(j, 'organisatie')),[`username`]: (getObjectProperty(j, 'username')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`btwplichtig`]: (getObjectProperty(j, 'btwplichtig')),[`rol`]: (getObjectProperty(j, 'rol')),[`tariefkm`]: (getObjectProperty(j, 'tariefkm')),[`tariefuur`]: (getObjectProperty(j, 'tariefuur')),[`email`]: (getObjectProperty(j, 'email')) }) );
  }
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((String('userStatus=\'ENABLED\'') + String(' AND rol = \'beheerder\''))) }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('objectId is not null') }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('userStatus=\'ENABLED\'') }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index2 in userslist2) {
    l = userslist2[l_index2];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify((String('userStatus=\'ENABLED\'') + String(' AND rol = \'beheerder\''))) }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index2 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  await ZSD();
  console.log('permissions gebruikersbeheer uitgevoerd');
  (function (message) { alert(message) })('permissions gebruikersbeheer uitgevoerd');
}

/**
 * Describe this function...
 */
async function ZSD() {
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('username=\'Dnn73mwn\'') }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index3 in userslist2) {
    l = userslist2[l_index3];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('rol=\'ZSD\' OR rol=\'NCZSD\'') }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index3 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index3];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('rol=\'ZSD\' OR rol=\'NCZSD\'') }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index4 in userslist2) {
    l = userslist2[l_index4];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('username=\'Dnn73mwn\'') }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index4 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index4];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
}


  await permissionsgebruikersbeheer();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/a68db61433b22daeb3e3c9beb0d3c9b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, userslist2, item, users2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': ' userStatus=\'ENABLED\'','properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('permissions users uitgevoerd');
  (function (message) { alert(message) })('permissions users uitgevoerd');
}


  await permissionsusers();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/bfb66cb2f42e8afcf5b28649842d0c4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newuser, l, k, beheerderslist, item, beheerders, j, declaratieslist, declaraties, userslist, users, gegevenslist, gegevens, m, gebruikersbeheerlist, gebruikersbeheer, userslist2, users2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function instellen_permissions() {
  await permissionsdeclaraties();
  await permissionsfacturatieadresgegevens();
  await permissionsfactuurgegevens();
  await permissionsgebruikersbeheer();
  await permissionsusers();
  if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'beheerder') {
    await permissionsmaandafsluiten();
    await permissionsdeclaratiesbeheerders();
  }
}

/**
 * Describe this function...
 */
async function permissionsdeclaraties() {
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join(''))) }).send());
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(j, 'username')),'\''].join(''))) }).send());
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify((['centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol=\'beheerder\''].join(''))) }).send());
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index in beheerderslist) {
        l = beheerderslist[l_index];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaratiesmnl',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions declaraties uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsfacturatieadresgegevens() {
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join(''))) }).send());
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index2 in userslist) {
    j = userslist[j_index2];
    declaraties = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('facturatieadresgegevens'),'whereClause': JSON.stringify('objectId is not null') }).send());
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index2 in declaratieslist) {
      k = declaratieslist[k_index2];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('rol=\'beheerder\'') }).send());
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index2 in beheerderslist) {
        l = beheerderslist[l_index2];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions facturatieadresgegevens uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsfactuurgegevens() {
  await Backendless.Data.of('factuurgegevens').save( ({ [`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')) }) );
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join(''))) }).send());
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index3 in userslist) {
    j = userslist[j_index3];
    gegevens = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('factuurgegevens'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(j, 'username')),'\''].join(''))) }).send());
    gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index3 in gegevenslist) {
      k = gegevenslist[k_index3];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions factuurgegevens uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join(''))) }).send());
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index4 in userslist) {
    j = userslist[j_index4];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`dashboardnaam`]: (getObjectProperty(j, 'dashboardnaam')),[`naam`]: (getObjectProperty(j, 'naam')),[`organisatie`]: (getObjectProperty(j, 'organisatie')),[`username`]: (getObjectProperty(j, 'username')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`btwplichtig`]: (getObjectProperty(j, 'btwplichtig')),[`rol`]: (getObjectProperty(j, 'rol')),[`tariefkm`]: (getObjectProperty(j, 'tariefkm')),[`tariefuur`]: (getObjectProperty(j, 'tariefuur')),[`email`]: (getObjectProperty(j, 'email')) }) );
  }
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((String('userStatus=\'ENABLED\'') + String(' AND rol = \'beheerder\''))) }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index3 in userslist2) {
    l = userslist2[l_index3];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('objectId is not null') }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('userStatus=\'ENABLED\'') }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index4 in userslist2) {
    l = userslist2[l_index4];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify((String('userStatus=\'ENABLED\'') + String(' AND rol = \'beheerder\''))) }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index2 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  console.log('permissions gebruikersbeheer uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join(''))) }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index5 in userslist2) {
    l = userslist2[l_index5];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('permissions users uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsmaandafsluiten() {
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join(''))) }).send());
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index5 in userslist) {
    j = userslist[j_index5];
    declaraties = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('maandafsluiten'),'whereClause': JSON.stringify('objectId is not null') }).send());
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index4 in declaratieslist) {
      k = declaratieslist[k_index4];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions maandafsluiten uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesbeheerders() {
  declaraties = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify('objectId is not null') }).send());
  declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var k_index5 in declaratieslist) {
    k = declaratieslist[k_index5];
    beheerders = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('rol=\'beheerder\'') }).send());
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index6 in beheerderslist) {
      l = beheerderslist[l_index6];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions declaraties beheerder uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties beheerder uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionfiles() {
  users = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join(''))).setProperties(['objectId']).setPageSize(10)));
  userslist = (await Promise.all(users.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var j_index6 in userslist) {
    j = userslist[j_index6];
    await Backendless.Files.Permissions.READ.grantForUser(j, (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(___arguments.context.pageData, 'usernameregister'))].join('')));
    await Backendless.Files.Permissions.DELETE.grantForUser(j, (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(___arguments.context.pageData, 'usernameregister'))].join('')));
    await Backendless.Files.Permissions.WRITE.grantForUser(j, (['kopiescan',(getObjectProperty(___arguments.context.pageData, 'centra')),'/',(getObjectProperty(___arguments.context.pageData, 'usernameregister'))].join('')));
    users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((['userStatus=\'ENABLED\' AND centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND rol= \'beheerder\'',' OR ','userStatus=\'ENABLED\' AND centra=\'',(getObjectProperty(___arguments.context.pageData, 'centra')),'\' AND viewprojectenblock = TRUE'].join(''))) }).send());
    userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var k_index6 in userslist2) {
      k = userslist2[k_index6];
      await Backendless.Files.Permissions.READ.grantForUser(k, (String('kopiescan') + String(getObjectProperty(___arguments.context.pageData, 'centra'))));
    }
  }
  console.log('permissions files uitgevoerd');
}


  ___arguments.context.pageData['spinner'] = true;
  ___arguments.context.pageData['tariefkm'] = 3100;
  if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'ZSD') {
    ___arguments.context.pageData['tariefuur'] = 1200000;
  } else {
    ___arguments.context.pageData['tariefuur'] = 816000;
  }
  newuser = (await Backendless.UserService.register( new Backendless.User({ 'naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')),'username': (getObjectProperty(___arguments.context.pageData, 'usernameregister')),'password': 'CVL2022isBegonnen!@!','btwplichtig': (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),'rol': (getObjectProperty(___arguments.context.pageData, 'rol')),'tariefkm': (getObjectProperty(___arguments.context.pageData, 'tariefkm')),'tariefuur': (getObjectProperty(___arguments.context.pageData, 'tariefuur')) }) ));
  await instellen_permissions();
  (function (message) { alert(message) })((['User is geregistreerd: \n',['Username:  ',(getObjectProperty(newuser, 'username')),' \n'].join(''),['Naam: ',(getObjectProperty(newuser, 'naam')),' \n'].join(''),['Email:  ',(getObjectProperty(newuser, 'email')),' \n'].join(''),['Rol:  ',(getObjectProperty(newuser, 'rol')),' \n'].join(''),['btwplichtig:  ',(getObjectProperty(newuser, 'btwplichtig')),' \n'].join('')].join('')));
  await Backendless.Data.of('newuserrequests').bulkUpdate( (['naam=\'',(getObjectProperty(newuser, 'naam')),'\''].join('')), ({ [`useraangemaakt`]: true }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setPageSize(10))));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/05ab59ac7c3b9157ad86d6a130cb67a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause('dashboardnaam NOT LIKE \'lorio%\'').setProperties('dashboardnaam').setSortBy('created DESC').setPageSize(10)))[0]), 'dashboardnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/permissions/components/9449ebc70bf23e2a1d64b969cf6647d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospice')) == 'Transfer bureau' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/permissions/components/543c1647fb91edcf0518d46c37752178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, j, declaratieslist, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsfacturatieadresgegevens() {
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('objectId is not null') }).send());
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('facturatieadresgegevens'),'whereClause': JSON.stringify('objectId is not null') }).send());
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('rol=\'beheerder\'') }).send());
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index in beheerderslist) {
        l = beheerderslist[l_index];
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions facturatieadresgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions facturatieadresgegevens uitgevoerd');
}


  await permissionsfacturatieadresgegevens();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/6c3d7b18c98f6608c648ab78251bce44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, gegevenslist, item, gegevens, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsfactuurgegevens() {
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('objectId is not null') }).send());
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    gegevens = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('factuurgegevens'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(j, 'username')),'\''].join(''))) }).send());
    gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in gegevenslist) {
      k = gegevenslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions factuurgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions factuurgegevens uitgevoerd');
}


  await permissionsfactuurgegevens();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/c3c8692edd7df313d0589228c22790e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  var j_list = ['naam', 'email', 'organisatie', 'usernameregister', 'btwplichtig', 'rol', null, null, null, null, null, null];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData[j] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/f8daf5872d2777cc4a819fead57ce1b7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/permissions/components/7622db78b4a8b818b068046e27e81c18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('newuserrequests').save( ___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58') );
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'btwplichtig'));
  ___arguments.context.pageData['email'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'email'));
  ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'naam'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'organisatie'));
  ___arguments.context.pageData['team'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'team'));
  ___arguments.context.pageData['rol'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'rol'));
  ___arguments.context.pageData['aangemelddoor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'aangemelddoor'));
  ___arguments.context.pageData['aangemelddooremail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'aangemelddooremail'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/permissions/components/7cef7da404088638c51e3a888e53ae58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, declaratieslist, item, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsmaandafsluiten() {
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('rol=\'beheerder\'') }).send());
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('maandafsluiten'),'whereClause': JSON.stringify('objectId is not null') }).send());
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions maandafsluiten uitgevoerd');
  (function (message) { alert(message) })('permissions maandafsluiten uitgevoerd');
}


  await permissionsmaandafsluiten();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/57c849c81b7887b8300328298235b709/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log(await Backendless.UserService.findByRole('beheerder', false, Backendless.DataQueryBuilder.create().setPageSize(100)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/06ae39ec3388491b5458344b5f081e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, k, zsdbeheerderlist, item, zsdbeheerder, declaratieslist, declaraties, j, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratieszsd() {
  declaraties = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['subsidie=\'','ZSD','\''].join(''))) }).send());
  declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var k_index in declaratieslist) {
    k = declaratieslist[k_index];
    zsdbeheerder = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('username=\'Dnn73mwn\'') }).send());
    zsdbeheerderlist = (await Promise.all(zsdbeheerder.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var m_index in zsdbeheerderlist) {
      m = zsdbeheerderlist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions declaraties ZSD uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties ZSD uitgevoerd');
}


  await permissionsdeclaratieszsd();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/3848b36881a8b3d87de847a8dccb6618/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, declaratieslist, declaraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesbeheerders() {
  declaraties = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify('objectId is not null') }).send());
  declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var k_index in declaratieslist) {
    k = declaratieslist[k_index];
    beheerders = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify((['rol=\'Beheerder\' AND username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join(''))) }).send());
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index in beheerderslist) {
      l = beheerderslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions declaraties beheerder uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties beheerder uitgevoerd');
}


  await permissionsdeclaratiesbeheerders();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/cfb63f383178b0f70c9813583de8b16a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('de', ({ [`dateStyle`]: 'medium',[`timeStyle`]: 'short' })).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9bf11f9857d85dbfd848af38b4386528'), 'created'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/permissions/components/e025fc25b46318d80ab8f0f5ca5314e8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e025fc25b46318d80ab8f0f5ca5314e8', (await Backendless.Data.of('historieaanmeldingusers').find(Backendless.DataQueryBuilder.create().setWhereClause('actie=\'Aanvraag tot deactiveren\' AND usergedeactiveerd = 0').setSortBy('created DESC').setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/permissions/components/176879631d25e7d800e85388fdbb3598/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['aangemelddooremail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9bf11f9857d85dbfd848af38b4386528'), 'aangemelddooremail'));
  ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9bf11f9857d85dbfd848af38b4386528'), 'naam'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9bf11f9857d85dbfd848af38b4386528'), 'organisatie'));
  ___arguments.context.pageData['username'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9bf11f9857d85dbfd848af38b4386528'), 'username'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/permissions/components/60380f65af54d86840f83f64c52e5098/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var countregistraties, countdossiers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e98660b0c33bc78f9e83c72e65e00e9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03a8d5a8bca19f2fdab80f98bbf83438', false);
  countregistraties = (await Backendless.Data.of('declaraties').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')))));
  if (countregistraties == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03a8d5a8bca19f2fdab80f98bbf83438', true);
    (function (message) { alert(message) })((String(['Aantal declaraties: ',countregistraties,' \n'].join('')) + String(String('Deze user moet verwijderd worden'))));
  }
  if (countregistraties != 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e98660b0c33bc78f9e83c72e65e00e9', true);
    (function (message) { alert(message) })((['',['Aantal declaraties: ',countregistraties,' \n'].join(''),String('Deze user moet gedeactiveerd worden')].join('')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/1e98660b0c33bc78f9e83c72e65e00e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, userslist2, item, users2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function factuurgegevens() {
  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`adres`]: null,[`bedrijfsnaam`]: null,[`btwnummer`]: null,[`email`]: null,[`extrainformatie`]: null,[`factuurkwitantie`]: null,[`factuurnummer`]: null,[`ibannummer`]: null,[`ibantennamevan`]: null,[`kvknummer`]: null,[`logo`]: null,[`postcode`]: null,[`telefoon`]: null,[`telefoonnummer`]: null,[`woonplaats`]: null }) );
}

/**
 * Describe this function...
 */
async function Users() {
  await Backendless.Request.post(`${Backendless.appPath}/services/disableuser/disableuser`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'userobjectId'))));
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))) }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    await Backendless.Data.Permissions.FIND.denyForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.denyForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
}

/**
 * Describe this function...
 */
async function gebruikersbeheer() {
  await Backendless.Data.of('gebruikersbeheer').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`email`]: null,[`userStatus`]: 'DISABLED' }) );
}

/**
 * Describe this function...
 */
async function userobjectId() {
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'objectId'));
}

/**
 * Describe this function...
 */
async function declaraties() {
  await Backendless.Data.of('declaraties').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`email`]: null }) );
}


  await userobjectId();
  await Users();
  await factuurgegevens();
  await gebruikersbeheer();
  await declaraties();
  await Backendless.Messaging.sendEmailFromTemplate('usergedeactiveerd', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'aangemelddooremail')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`aangemelddoor`]: (getObjectProperty(___arguments.context.pageData, 'aangemelddoor')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')) }), undefined);
  await Backendless.Data.of('historieaanmeldingusers').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`usergedeactiveerd`]: true }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e025fc25b46318d80ab8f0f5ca5314e8', (await Backendless.Data.of('historieaanmeldingusers').find(Backendless.DataQueryBuilder.create().setWhereClause('actie=\'Aanvraag tot deactiveren\' AND usergedeactiveerd = 0').setSortBy('created DESC').setPageSize(100))));
  (function (message) { alert(message) })('User is gedeactiveerd en de email is verzonden naar de aanvrager');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/03a8d5a8bca19f2fdab80f98bbf83438/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function userobjectId() {
  ___arguments.context.pageData['userobjectId'] = (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0]), 'objectId'));
}

/**
 * Describe this function...
 */
async function Users() {
  await Backendless.Data.of('Users').bulkDelete( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')) );
}

/**
 * Describe this function...
 */
async function factuurgegevens() {
  await Backendless.Data.of('factuurgegevens').bulkDelete( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')) );
}

/**
 * Describe this function...
 */
async function gebruikersbeheer() {
  await Backendless.Data.of('factuurgegevens').bulkDelete( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')) );
}


  await userobjectId();
  await Users();
  await factuurgegevens();
  await gebruikersbeheer();
  await Backendless.Messaging.sendEmailFromTemplate('usergedeactiveerd', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'aangemelddooremail')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`aangemelddoor`]: (getObjectProperty(___arguments.context.pageData, 'aangemelddoor')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'username')) }), undefined);
  await Backendless.Data.of('historieaanmeldingusers').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join('')), ({ [`usergedeactiveerd`]: true }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e025fc25b46318d80ab8f0f5ca5314e8', (await Backendless.Data.of('historieaanmeldingusers').find(Backendless.DataQueryBuilder.create().setWhereClause('actie=\'Aanvraag tot deactiveren\' AND usergedeactiveerd = 0').setSortBy('created DESC').setPageSize(100))));
  (function (message) { alert(message) })('User is verwijderd en de email is verzonden naar de aanvrager');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/d208a428002894c4c13a3ee8b5ec0928/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  var j_list = ['naam', 'organisatie', 'username'];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData[j] = null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e98660b0c33bc78f9e83c72e65e00e9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03a8d5a8bca19f2fdab80f98bbf83438', false);

  },
  /* handler:onClick */
  /* content */
}))

